{
  "common": {
    "from": "{{price}}-ից",
    "soon": "շուտով",
    "online": "Առցանց",
    "back": "Հետ",
    "close": "Փակել",
    "cancel": "Չեղարկել",
    "apply": "Կիրառել",
    "retry": "Կրկնել",
    "retryLater": "Փորձեք մի փոքր ուշ։",
    "loading": "Բեռնվում է…",
    "increase": "Ավելի",
    "decrease": "Պակաս"
  },
  "categories": {
    "HOME": {
      "name": "Կենցաղ",
      "short": "Մաքրում, վերանորոգում, տրանսֆեր"
    },
    "DOCS": {
      "name": "Փաստաթղթեր",
      "short": "Սոցքարտ, թարգմանություն, կացության քարտ"
    },
    "LEARNING": {
      "name": "Ուսում և կարիերա",
      "short": "Լեզուներ և կարիերայի խորհրդատու"
    },
    "PERKS": {
      "name": "Զեղչեր և նվերներ",
      "short": "Սրճարաններ, ռեստորաններ, նվերներ"
    }
  },
  "services": {
    "cleaning": {
      "name": "Մաքրում",
      "description": "Սովորական, գլխավոր կամ վերանորոգումից հետո։ Ստուգված մասնագետներ և լուսանկարային հաշվետվություն։"
    },
    "repair": {
      "name": "Վերանորոգում",
      "description": "Սանտեխնիկա, էլեկտրիկա և մանր վերանորոգում։ Վարպետը նախահաշիվը համաձայնեցնում է նախքան աշխատանքը։"
    },
    "transfer": {
      "name": "Տրանսֆեր",
      "description": "Կդիմավորենք օդանավակայանում կամ կտանենք չվերթին։"
    },
    "social_card": {
      "name": "Սոցիալական քարտ",
      "description": "Կօգնենք ձևակերպել սոցիալական քարտը։"
    },
    "passport_translation": {
      "name": "Անձնագրի թարգմանություն",
      "description": "Անձնագրի նոտարական թարգմանություն։"
    },
    "residence_permit": {
      "name": "Կացության քարտ",
      "description": "Ուղեկցում մինչև կացության քարտի ստացումը։"
    },
    "lang_armenian": {
      "name": "Հայերեն",
      "description": "Հայերենի դասերի փաթեթ՝ առցանց կամ անձամբ։"
    },
    "lang_english": {
      "name": "Անգլերեն",
      "description": "Անգլերենի դասերի փաթեթ՝ առցանց կամ անձամբ։"
    },
    "career": {
      "name": "Կարիերայի խորհրդատու",
      "description": "Ինքնակենսագրության վերլուծություն և աշխատանքի որոնման պլան։"
    }
  },
  "params": {
    "cleaning": {
      "cleaningType": {
        "label": "Մաքրման տեսակ",
        "regular": "Սովորական",
        "regular_hint": "Պահպանողական մաքրում",
        "general": "Գլխավոր",
        "general_hint": "Ամեն ինչ, ներառյալ դժվարամատչելի տեղերը",
        "renovation": "Վերանորոգումից հետո",
        "renovation_hint": "Փոշի, ներկի և ցեմենտի հետքեր"
      },
      "rooms": {
        "label": "Սենյակներ",
        "count_one": "{{count}} սենյակ",
        "count_few": "{{count}} սենյակ",
        "count_many": "{{count}} սենյակ",
        "count_other": "{{count}} սենյակ"
      },
      "bathrooms": {
        "label": "Սանհանգույցներ",
        "count_one": "{{count}} սանհանգույց",
        "count_few": "{{count}} սանհանգույց",
        "count_many": "{{count}} սանհանգույց",
        "count_other": "{{count}} սանհանգույց"
      }
    },
    "repair": {
      "repairType": {
        "label": "Ինչ է պատահել",
        "plumbing": "Սանտեխնիկա",
        "plumbing_hint": "Ծորակներ, խողովակներ, զուգարան",
        "electrical": "Էլեկտրիկա",
        "electrical_hint": "Վարդակներ, լույս, լարեր",
        "minor": "Մանր վերանորոգում",
        "minor_hint": "Դարակներ, դռներ, կահույք"
      },
      "problem": {
        "label": "Նկարագրեք խնդիրը"
      }
    },
    "transfer": {
      "direction": {
        "label": "Ուղղություն",
        "fromAirport": "Օդանավակայանից",
        "fromAirport_hint": "Կդիմավորենք ցուցանակով",
        "toAirport": "Օդանավակայան",
        "toAirport_hint": "Կտանենք չվերթին"
      },
      "flight": {
        "label": "Չվերթի համար"
      },
      "passengers": {
        "label": "Ուղևորներ"
      },
      "luggage": {
        "label": "Ուղեբեռի տեղեր"
      }
    },
    "social_card": {
      "forWhom": {
        "label": "Ում համար",
        "self": "Ինձ համար",
        "self_hint": "Մեկ անձ",
        "family": "Ընտանիքի համար",
        "family_hint": "Մի քանի անձ"
      }
    },
    "passport_translation": {
      "forWhom": {
        "label": "Ում համար",
        "self": "Ինձ համար",
        "self_hint": "Մեկ անձնագիր",
        "family": "Ընտանիքի համար",
        "family_hint": "Մի քանի անձնագիր"
      }
    },
    "residence_permit": {
      "forWhom": {
        "label": "Ում համար",
        "self": "Ինձ համար",
        "self_hint": "Մեկ անձ",
        "family": "Ընտանիքի համար",
        "family_hint": "Մի քանի անձ"
      }
    },
    "lang_armenian": {
      "level": {
        "label": "Մակարդակ",
        "A1": "A1",
        "A1_hint": "Զրոյից",
        "A2": "A2",
        "A2_hint": "Հիմնական",
        "B1": "B1",
        "B1_hint": "Միջին",
        "B2": "B2",
        "B2_hint": "Միջինից բարձր"
      },
      "format": {
        "label": "Ձևաչափ",
        "online": "Առցանց",
        "online_hint": "Տեսազանգով",
        "offline": "Անձամբ",
        "offline_hint": "Երևանում"
      },
      "lessons": {
        "label": "Փաթեթ",
        "4": "4 դաս",
        "4_hint": "Փորձելու համար",
        "8": "8 դաս",
        "8_hint": "Մեկ ամիս",
        "12": "12 դաս",
        "12_hint": "Ինտենսիվ"
      }
    },
    "lang_english": {
      "level": {
        "label": "Մակարդակ",
        "A1": "A1",
        "A1_hint": "Զրոյից",
        "A2": "A2",
        "A2_hint": "Հիմնական",
        "B1": "B1",
        "B1_hint": "Միջին",
        "B2": "B2",
        "B2_hint": "Միջինից բարձր",
        "C1": "C1",
        "C1_hint": "Առաջադեմ"
      },
      "format": {
        "label": "Ձևաչափ",
        "online": "Առցանց",
        "online_hint": "Տեսազանգով",
        "offline": "Անձամբ",
        "offline_hint": "Երևանում"
      },
      "lessons": {
        "label": "Փաթեթ",
        "4": "4 դաս",
        "4_hint": "Փորձելու համար",
        "8": "8 դաս",
        "8_hint": "Մեկ ամիս",
        "12": "12 դաս",
        "12_hint": "Ինտենսիվ"
      }
    },
    "career": {
      "topic": {
        "label": "Թեմա",
        "resume": "Ինքնակենսագրության վերլուծություն",
        "resume_hint": "Ինչ բարելավել",
        "jobSearch": "Աշխատանքի որոնման պլան",
        "jobSearch_hint": "Որտեղ և ինչպես դիմել"
      }
    }
  },
  "extras": {
    "windows": {
      "name": "Պատուհանների լվացում",
      "per": "մեկ պատուհանի համար"
    },
    "balconyGlazing": {
      "name": "Պատշգամբի ապակեպատում",
      "per": "մեկ պատշգամբի համար"
    },
    "balcony": {
      "name": "Պատշգամբի մաքրում",
      "per": "մեկ պատշգամբի համար"
    },
    "fridge": {
      "name": "Սառնարանի ներսը"
    },
    "oven": {
      "name": "Ջեռոցի ներսը"
    },
    "microwave": {
      "name": "Միկրոալիքային վառարանի ներսը"
    },
    "kitchenCabinets": {
      "name": "Խոհանոցային պահարանների ներսը"
    },
    "complexKitchen": {
      "name": "Շատ աղտոտված խոհանոց"
    },
    "chandelier": {
      "name": "Ջահ",
      "per": "մեկ հատի համար"
    },
    "wardrobe": {
      "name": "Հանդերձարան"
    },
    "limescale": {
      "name": "Նստվածք և ժանգ սանհանգույցում"
    },
    "petHair": {
      "name": "Ընտանի կենդանիների մազերի հեռացում"
    },
    "litter": {
      "name": "Կենդանու սկուտեղ",
      "per": "մեկ հատի համար"
    },
    "ironing": {
      "name": "Արդուկում",
      "per": "մեկ ժամի համար"
    },
    "extraTime": {
      "name": "Լրացուցիչ ժամանակ",
      "per": "30 րոպեի համար"
    },
    "keys": {
      "name": "Բանալիների վերցնում և վերադարձ"
    },
    "experienced": {
      "name": "Փորձառու մաքրող"
    },
    "vacuum": {
      "name": "Բերել փոշեկուլ"
    }
  },
  "checklist": {
    "kitchen": "Խոհանոց",
    "bathroom": "Սանհանգույց",
    "rooms": "Սենյակներ",
    "floors": "Հատակներ",
    "photoReport": "Լուսանկարային հաշվետվություն",
    "diagnostics": "Ախտորոշում",
    "estimate": "Նախահաշիվ",
    "repair": "Վերանորոգում",
    "photo": "Լուսանկար",
    "luggage": "Ուղեբեռ",
    "address": "Հասցե",
    "review": "Կրկնություն",
    "newTopic": "Նոր թեմա",
    "homework": "Տնային առաջադրանք",
    "resume": "Ինքնակենսագրություն",
    "plan": "Պլան",
    "materials": "Նյութեր"
  },
  "status": {
    "CLEANING": {
      "NEW": "Նոր",
      "ASSIGNED": "Նշանակված",
      "EN_ROUTE": "Ճանապարհին",
      "CLEANING": "Մաքրում",
      "DONE": "Պատրաստ է",
      "CANCELLED": "Չեղարկված"
    },
    "REPAIR": {
      "NEW": "Նոր",
      "ASSIGNED": "Նշանակված",
      "ON_SITE": "Տեղում է",
      "ESTIMATE_APPROVED": "Նախահաշիվը համաձայնեցված է",
      "REPAIRING": "Վերանորոգում",
      "DONE": "Պատրաստ է",
      "CANCELLED": "Չեղարկված"
    },
    "TRANSFER": {
      "NEW": "Նոր",
      "ASSIGNED": "Նշանակված",
      "DRIVER_WAITING": "Վարորդը սպասում է",
      "RIDE_IN_PROGRESS": "Ճանապարհին",
      "COMPLETED": "Ավարտված",
      "CANCELLED": "Չեղարկված"
    },
    "LANGUAGE": {
      "ENROLLED": "Գրանցված",
      "LESSON_SCHEDULED": "Դասը նշանակված է",
      "LESSON_IN_PROGRESS": "Դասն ընթացքում է",
      "LESSON_DONE": "Դասն ավարտված է",
      "COMPLETED": "Փաթեթն անցած է",
      "CANCELLED": "Չեղարկված"
    },
    "CAREER": {
      "NEW": "Նոր",
      "CONSULTANT_ASSIGNED": "Խորհրդատուն նշանակված է",
      "RESUME_RECEIVED": "Ինքնակենսագրությունը ստացված է",
      "MEETING": "Հանդիպում",
      "PLAN_SENT": "Պլանն ուղարկված է",
      "CANCELLED": "Չեղարկված"
    },
    "DOCUMENTS": {
      "NEW": "Նոր",
      "DOCS_REVIEW": "Փաստաթղթերը ստուգվում են",
      "NEEDS_MORE_DOCS": "Անհրաժեշտ են լրացուցիչ փաստաթղթեր",
      "SUBMITTED": "Ներկայացված",
      "DONE": "Պատրաստ է",
      "CANCELLED": "Չեղարկված"
    }
  },
  "payment": {
    "UNPAID": "Չվճարված",
    "PAID": "Վճարված",
    "REFUNDED": "Վերադարձված"
  },
  "roles": {
    "CLEANER": "Մաքրող",
    "HANDYMAN": "Վարպետ",
    "DRIVER": "Վարորդ",
    "TEACHER": "Դասավանդող",
    "CAREER_CONSULTANT": "Կարիերայի խորհրդատու",
    "DOCS_AGENT": "Փաստաթղթերի մասնագետ"
  },
  "districts": {
    "ajapnyak": "Աջափնյակ",
    "arabkir": "Արաբկիր",
    "avan": "Ավան",
    "davtashen": "Դավթաշեն",
    "erebuni": "Էրեբունի",
    "kanaker_zeytun": "Քանաքեռ-Զեյթուն",
    "kentron": "Կենտրոն",
    "malatia_sebastia": "Մալաթիա-Սեբաստիա",
    "nork_marash": "Նորք-Մարաշ",
    "nor_nork": "Նոր Նորք",
    "nubarashen": "Նուբարաշեն",
    "shengavit": "Շենգավիթ"
  },
  "plans": {
    "free": {
      "perks": "Գործընկերների զեղչեր և նվերներ",
      "prices": "Բոլոր ծառայությունները սովորական գնով",
      "status": "Հայտերի կարգավիճակներ և չատ"
    },
    "plus": {
      "price": "{{price}}/ամիս",
      "all": "Ամեն ինչ Barev-ից",
      "discount": "−{{pct}}% «{{category}}» ուղղությամբ"
    }
  },
  "errors": {
    "generic": "Ինչ-որ բան սխալ գնաց։ Փորձեք կրկին։",
    "NOT_FOUND": "Այդ պատվերը չգտանք։",
    "FORBIDDEN": "Մուտքն արգելված է։",
    "CONSENT_REQUIRED": "Նախ անհրաժեշտ է անձնական տվյալների մշակման համաձայնություն։",
    "SERVICE_UNAVAILABLE": "Այս ծառայությունը դեռ հասանելի չէ։",
    "INVALID_PARAMS": "Ստուգեք պատվերի տվյալները։",
    "SLOT_UNAVAILABLE": "Այս ժամն արդեն զբաղված է։ Ընտրեք այլ ժամ։",
    "ADDRESS_REQUIRED": "Նշեք վարչական շրջանը և հասցեն։",
    "TRANSITION_NOT_ALLOWED": "Այս քայլը հիմա հասանելի չէ։ Թարմացրեք էկրանը։",
    "CHECKLIST_INCOMPLETE": "Նշեք ստուգաթերթի բոլոր կետերը։",
    "PHOTO_REQUIRED": "Այս կետի համար անհրաժեշտ է լուսանկար։",
    "ESTIMATE_NOT_ACCEPTED": "Հաճախորդը դեռ չի համաձայնեցրել նախահաշիվը։",
    "CANCEL_VIA_OPERATOR": "Ծառայությունն արդեն սկսվել է․ չեղարկել կարելի է միայն օպերատորի միջոցով։",
    "RESCHEDULE_VIA_OPERATOR": "Տեղափոխել կարելի է միայն օպերատորի միջոցով։",
    "AGENCY_CODE_INVALID": "Այդպիսի կոդ չկա։ Ստուգեք պայմանագրի կոդը։",
    "AGENCY_ALREADY_SET": "Դուք արդեն կապված եք այլ անշարժ գույքի գործակալության հետ։",
    "OFFER_NOT_ACTIVE": "Առաջարկն այլևս արդիական չէ։",
    "PROVIDER_BUSY": "Մասնագետն այդ ժամին զբաղված է։",
    "ALREADY_ASSIGNED": "Պատվերն արդեն նշանակված է։",
    "INVITE_INVALID": "Հրավերի հղումն անվավեր է։ Խնդրեք նորը օպերատորից։",
    "NOT_PAID_STATE": "Այս պատվերը հնարավոր չէ նշել որպես վճարված։",
    "BAD_CREDENTIALS": "Սխալ մուտքանուն կամ գաղտնաբառ։",
    "BAD_TOTP": "Սխալ կոդ։ Ստուգեք հեռախոսի ժամը։",
    "LOGIN_THROTTLED": "Չափազանց շատ փորձեր։ Սպասեք 15 րոպե։",
    "OWNER_ONLY": "Հասանելի է միայն սեփականատիրոջը։",
    "NOT_LINKED": "Հաշիվը կապված չէ։",
    "NOT_PROVIDER": "Հասանելի է միայն մասնագետներին։",
    "CANNOT_DISABLE_SELF": "Չեք կարող անջատել ինքներդ ձեզ։",
    "AGENCY_CODE_FORMAT": "Կոդը պետք է լինի լատինատառ և թվեր։",
    "TOTP_ALREADY_ENABLED": "2FA-ն արդեն կարգավորված է։",
    "ADMIN_LOGIN_REQUIRED": "Անհրաժեշտ է մուտք գործել։",
    "ADMIN_2FA_REQUIRED": "Հաստատեք մուտքը կոդով։",
    "INIT_DATA_MISSING": "Բացեք հավելվածը Telegram-ի միջոցով։",
    "INIT_DATA_BAD_HASH": "Բացեք հավելվածը Telegram-ի միջոցով։",
    "INIT_DATA_EXPIRED": "Սեսիան հնացել է։ Բացեք հավելվածը նորից։",
    "BAD_FILE_TYPE": "Անհրաժեշտ է լուսանկար (JPG, PNG, WEBP)։",
    "NO_FILE": "Ֆայլն ընտրված չէ։",
    "UPLOAD": "Չհաջողվեց վերբեռնել լուսանկարը։",
    "PHONE_INVALID": "Ստուգիր հեռախոսահամարը։",
    "REQUEST_THROTTLED": "Չափազանց շատ հայտեր անընդմեջ։ Փորձիր 15 րոպեից։",
    "CONTACT_INVALID": "Անհրաժեշտ է հեռախոս (+374…) կամ Telegram-ի անուն (@username)։",
    "NAME_REQUIRED": "Գրեք, թե ինչպես դիմել ձեզ։",
    "PROVIDER_NOT_LINKED": "Կատարողը դեռ չի բացել աշխատանքային բոտը հրավերով՝ գրելու տեղ չկա։",
    "CARD_EXPIRED": "QR-ը հնացել է կամ անվավեր է՝ խնդրեք հաճախորդին նորից բացել քարտը։",
    "OFFER_NOT_AVAILABLE": "Այս առաջարկը հասանելի չէ հաճախորդի մակարդակում։",
    "OFFER_LIMIT_REACHED": "Այս առաջարկի սահմանաչափն արդեն սպառված է։",
    "CONCIERGE_SUBSCRIBERS_ONLY": "Անձնական կոնսիերժը Barev+ և Barev Elite բաժանորդների համար է։ Առայժմ գրեք աջակցությանը՝ մենք էլ կօգնենք։",
    "ASSIGNEE_NO_ACCESS": "Այս աշխատակիցը մուտք չունի այս ալիքին։",
    "PROMO_INVALID": "Նման պրոմոկոդ չկա",
    "PROMO_EXPIRED": "Պրոմոկոդն այլևս չի գործում",
    "PROMO_USED": "Այս պրոմոկոդն արդեն օգտագործված է",
    "PROMO_NOT_FOR_SERVICE": "Պրոմոկոդը չի գործում այս ծառայության համար",
    "POINTS_DUPLICATE_ORDER": "Այս պատվերի համար բարիկներն արդեն հաշվեգրվել են։",
    "POINTS_REASON_REQUIRED": "Նշեք պատճառը։",
    "POINTS_BELOW_MIN": "Գումարը նվազագույնից քիչ է։",
    "POINTS_NOT_ENOUGH": "Բարիկները չեն բավարարում։",
    "POINTS_OVER_SHARE": "Բարիկներով կարելի է վճարել պատվերի միայն մի մասը։",
    "POINTS_OVER_LIMIT": "Գերազանցում է ձեր սահմանաչափը․ պետք է սուպերադմինի հաստատում։",
    "POINTS_FINAL": "Այս գործողությունն այլևս հնարավոր չէ չեղարկել։",
    "POINTS_REQUEST_CLOSED": "Հայտն արդեն մշակված է կամ ժամկետանց։",
    "POINTS_TOO_MANY_REQUESTS": "Դուք արդեն ունեք սպասող հայտեր․ սպասեք պատասխանի։",
    "POINTS_WITH_PROMO": "Բարիկները չեն համատեղվում պրոմոկոդի հետ։",
    "PAYMENT_UNAVAILABLE": "Առցանց վճարումը հիմա հասանելի չէ — գրիր օպերատորին։",
    "PAYMENT_AMOUNT_OUT_OF_RANGE": "Այս գումարը հնարավոր չէ վճարել առցանց — օպերատորը կօգնի։",
    "ALREADY_SUBSCRIBED": "Քեզ մոտ արդեն կա ավտոերկարաձգմամբ բաժանորդագրություն։",
    "PAYMENT_PROVIDER_ERROR": "Վճարային ծառայությունը չպատասխանեց։ Փորձիր մի փոքր ուշ։"
  },
  "client": {
    "nav": {
      "label": "Նավիգացիա",
      "home": "Գլխավոր",
      "services": "Ծառայություններ",
      "newOrder": "Նոր պատվեր",
      "perks": "Զեղչեր",
      "profile": "Պրոֆիլ",
      "plan": "Պլան",
      "docs": "Փաստաթղթեր",
      "orders": "Պատվերներ",
      "card": "Քարտ",
      "chat": "Չատ"
    },
    "openInTelegram": {
      "title": "Բացեք Telegram-ում",
      "text": "Barev Club-ն աշխատում է Telegram-ի ներսում։ Մեր բոտում սեղմեք «Բացել հավելվածը»։"
    },
    "consent": {
      "title": "Գրեթե պատրաստ է",
      "text": "Պատվերներ ձևակերպելու համար անհրաժեշտ է ձեր համաձայնությունը անձնական տվյալների մշակմանը՝ անուն, հասցե և պատվերի մանրամասներ։ Դրանք ստանում են ձեր պատվերի կատարողը և քաղաքականությունում նշված գործընկերները, իսկ պահվում են Գերմանիայում գտնվող սերվերում։",
      "policyLink": "Գաղտնիության քաղաքականություն",
      "accept": "Համաձայն եմ, շարունակել",
      "giftToast": "Անշարժ գույքի գործակալության նվերն ակտիվացված է"
    },
    "home": {
      "hello": "Բարև՛",
      "guest": "Ընկեր",
      "myOrders": "Իմ հայտերը",
      "allOrders": "Բոլորը",
      "noOrders": "Դեռ հայտեր չկան։ Պատվիրեք առաջին ծառայությունը՝ ընդամենը 2 րոպե։",
      "repeatLast": "Կրկնել",
      "enterCode": "Անշարժ գույքի գործակալության կոդ",
      "plusUntil": "Barev+-ն ակտիվ է մինչև {{date}}",
      "discount": "−{{pct}}% Barev+-ով",
      "upsellTitle": "Մինչև −{{pct}}% Barev Elite-ով",
      "upsellText": "Մաքրում, վերանորոգում, տրանսֆեր, փաստաթղթեր և նվերներ գործընկերներից",
      "levelUntil": "{{plan}}-ը գործում է մինչև {{date}}",
      "now": "Հիմա",
      "moreActive": "Եվս ակտիվ՝ {{count}}",
      "orderTitle": "Պատվիրել",
      "cardShow": "Ցույց տալ QR",
      "free": "Անվճար մակարդակ",
      "chatTitle": "Ցանկացած հարց՝ չատում",
      "chatText": "Կպատասխանենք քո լեզվով"
    },
    "services": {
      "title": "Ծառայություններ",
      "plusDiscount": "Ձեր Barev+ զեղչը՝ −{{pct}}%",
      "callback": "Թողնել հայտ",
      "yourDiscount": "Քո զեղչը՝ −{{pct}}%",
      "withElite": "Barev Elite-ով՝ −{{pct}}%"
    },
    "order": {
      "unavailable": "Այս ծառայությունը շուտով հասանելի կլինի։",
      "duration": "Մոտ {{hours}} ժ",
      "when": "Երբ",
      "date": "Ամսաթիվ",
      "noSlots": "Այս օրը ազատ ժամ չկա։ Ընտրեք այլ օր։",
      "pickSlot": "Ընտրեք ժամը։",
      "address": "Հասցե",
      "district": "Վարչական շրջան",
      "districtPlaceholder": "Ընտրեք շրջանը",
      "pickDistrict": "Ընտրեք շրջանը։",
      "addressLabel": "Փողոց, շենք, բնակարան",
      "addressPlaceholder": "Պուշկինի 10, բն. 15",
      "enterAddress": "Նշեք հասցեն։",
      "note": "Նշում կատարողի համար",
      "notePlaceholder": "Դոմոֆոն, հարկ, ընտանի կենդանիներ…",
      "payment": "Վճարում",
      "paymentHint": "Վճարումը՝ կատարումից հետո։ Առցանց վճարումը կհայտնվի ավելի ուշ։",
      "price": "Արժեք",
      "discount": "Barev+ զեղչ −{{pct}}%",
      "plusHint": "Barev+-ով կլիներ {{pct}}%-ով էժան",
      "total": "Ընդամենը",
      "confirm": "Հաստատել պատվերը",
      "cancelPolicy": "Անվճար չեղարկում և տեղափոխում՝ ոչ ուշ, քան {{hours}} ժ առաջ։ Ավելի ուշ՝ պահվում է {{pct}}%։",
      "created": "Պատվեր #{{number}}-ը ստեղծված է",
      "extras": "Լրացուցիչ",
      "add": "Ավելացնել",
      "promo": "Պրոմոկոդ",
      "promoPlaceholder": "Պրոմոկոդ, եթե ունես",
      "promoApply": "Կիրառել",
      "promoRemove": "Հեռացնել",
      "promoLine": "Պրոմոկոդ {{code}} −{{pct}}%",
      "promoWeaker": "Բաժանորդագրության զեղչն ավելի մեծ է, գործում է այն"
    },
    "orders": {
      "title": "Իմ հայտերը",
      "active": "Ակտիվ",
      "history": "Պատմություն",
      "noHistory": "Այստեղ կհայտնվեն ավարտված պատվերները։",
      "order": "Պատվիրել ծառայություն"
    },
    "detail": {
      "progress": "Կարգավիճակ",
      "arrived": "տեղում է",
      "photoReport": "Լուսանկարային հաշվետվություն",
      "cancelFee": "Չեղարկման պահում",
      "reschedule": "Տեղափոխել",
      "rescheduleConfirm": "Տեղափոխել այս ժամին",
      "rescheduled": "Պատվերը տեղափոխված է",
      "cancel": "Չեղարկել պատվերը",
      "confirmCancelFree": "Չեղարկե՞լ պատվերը։ Չեղարկումն անվճար է։",
      "confirmCancelLate": "Մինչև սկիզբը մեկ օրից քիչ է մնացել՝ կպահենք {{fee}} ({{pct}}%)։ Չեղարկե՞լ։",
      "cancelled": "Պատվերը չեղարկված է",
      "cancelledWithFee": "Պատվերը չեղարկված է։ Պահում՝ {{fee}}",
      "viaOperator": "Սկզբից {{hours}} ժամից քիչ առաջ պատվերը չեղարկել կամ տեղափոխել կարելի է օպերատորի միջոցով՝ գրեք բոտին։",
      "repeat": "Կրկնել պատվերը",
      "orderAgain": "Պատվիրել կրկին",
      "providerLabel": {
        "CLEANING": "Մաքրող",
        "REPAIR": "Վարպետ",
        "TRANSFER": "Վարորդ",
        "LANGUAGE": "Դասավանդող",
        "CAREER": "Խորհրդատու",
        "DOCUMENTS": "Մասնագետ"
      },
      "when": "Երբ",
      "where": "Որտեղ",
      "who": "Կատարող",
      "whoPending": "ընտրում ենք",
      "payment": "Վճարում",
      "ask": "Հարց պատվերի վերաբերյալ",
      "payOnline": "Վճարել առցանց · {{price}}",
      "payOnlineHint": "Քարտով Tribute-ի միջոցով, եվրոյով՝ ըստ փոխարժեքի․ {{amd}} ≈ {{rub}}",
      "payAwaiting": "Սպասում ենք վճարման հաստատմանը…",
      "paidOnline": "Վճարումն անցավ, շնորհակալություն։"
    },
    "perks": {
      "title": "Զեղչեր",
      "soonTitle": "Գործընկերները շուտով",
      "soonText": "Այստեղ կհայտնվեն սրճարաններ, ռեստորաններ և գործընկերների նվերներ։ Վճարելիս ցույց տվեք ակումբային քարտը։"
    },
    "profile": {
      "title": "Պրոֆիլ",
      "fromAgency": "{{agency}} անշարժ գույքի գործակալության հաճախորդ",
      "noAgency": "Առանց անշարժ գույքի գործակալության",
      "membership": "Barev / Barev+ անդամակցություն",
      "codeTitle": "Անշարժ գույքի գործակալության կոդ",
      "codeText": "Բնակարանը վարձե՞լ եք գործընկեր անշարժ գույքի գործակալության միջոցով։ Մուտքագրեք պայմանագրի կոդը և ստացեք գործակալության նվերը։",
      "codePlaceholder": "Օրինակ՝ DOMIK",
      "codeAccepted": "Կոդն ընդունված է՝ {{agency}}",
      "codeGift": "Կոդն ընդունված է՝ {{agency}}։ Նվերն ակտիվացված է։",
      "language": "Լեզու"
    },
    "membership": {
      "title": "Անդամակցություն",
      "current": "Ձեր սակագինը",
      "howToGet": "Barev+-ը կարելի է ստանալ նվեր անշարժ գույքի գործակալության կոդով։ Առցանց բաժանորդագրությունը շուտով կհայտնվի։",
      "request": "Ձևակերպել {{plan}}",
      "requested": "Հայտն ուղարկված է, օպերատորը կկապվի",
      "requestHint": "Օպերատորը կգրի Telegram-ով, կհամաձայնեցնի վճարումը և կմիացնի բաժանորդագրությունը։",
      "pendingTitle": "Հայտն ուղարկված է",
      "pendingText": "Օպերատորը շուտով կկապվի բաժանորդագրությունը միացնելու համար։",
      "approx": "≈ {{amd}} · ≈ {{rub}} — վճարումը եվրոյով",
      "pay": "Ձևակերպել {{plan}}՝ {{price}}/ամիս",
      "payRenew": "Միացնել ավտոերկարաձգումը · {{price}}/ամիս",
      "payHint": "Վճարում քարտով Tribute-ի միջոցով։ Բաժանորդագրությունը երկարաձգվում է ամեն ամիս, կարող ես անջատել այստեղ ցանկացած պահի։",
      "payOther": "Վճարել այլ կերպ՝ օպերատորի միջոցով",
      "renewOn": "Ավտոերկարաձգումը միացված է",
      "nextCharge": "Հաջորդ գանձումը՝ {{date}} — {{price}}",
      "renewOffButton": "Անջատել ավտոերկարաձգումը",
      "renewOffConfirm": "Անջատե՞լ ավտոերկարաձգումը։ Բաժանորդագրությունը կգործի մինչև վճարված ամսվա ավարտը։",
      "renewOff": "Ավտոերկարաձգումն անջատված է",
      "switchHint": "Քեզ մոտ միացված է {{plan}}՝ ավտոերկարաձգմամբ։ Սակագինը փոխելու համար նախ անջատիր ավտոերկարաձգումը։",
      "awaitingTitle": "Սպասում ենք վճարման հաստատմանը",
      "awaitingText": "Սովորաբար մի քանի վայրկյան է։ Բաժանորդագրությունը կմիանա ավտոմատ։",
      "paid": "Վճարումն անցավ — բաժանորդագրությունը միացված է"
    },
    "segment": {
      "title": "Բարև։ Պատմիր քո մասին",
      "sub": "Ցույց կտանք այն, ինչ պետք է հենց քեզ։ Կարող ես փոխել պրոֆիլում։",
      "moving": "Տեղափոխվում եմ",
      "movingText": "Տեղափոխության պլան քայլ առ քայլ, փաստաթղթեր և կոնսիերժ",
      "living": "Արդեն ապրում եմ Հայաստանում",
      "livingText": "Զեղչված ծառայություններ, ակումբի գործընկերներ և պատվերներ",
      "profileTitle": "Իմ սցենարը"
    },
    "move": {
      "title": "Իմ տեղափոխությունը",
      "daysLeft_one": "{{count}} օրից",
      "daysLeft_few": "{{count}} օրից",
      "daysLeft_many": "{{count}} օրից",
      "daysLeft_other": "{{count}} օրից",
      "progress": "Պատրաստ է {{done}} քայլ {{total}}-ից",
      "noSteps": "Օպերատորը կկապվի և կկազմի պլանը, քայլերը կհայտնվեն այստեղ։",
      "afterTitle": "Արդեն տեղափոխվե՞լ ես",
      "afterText": "Պրոֆիլում ընտրիր «Արդեն ապրում եմ Հայաստանում»՝ այնտեղ են զեղչված ծառայություններն ու ակումբի գործընկերները։",
      "formHello": "{{name}}, սկսենք",
      "formTitle": "Հավաքենք քո տեղափոխությունը",
      "formSub": "Պատասխանիր մի քանի հարցի՝ օպերատորը կկազմի պլանը և կհաշվի գինը։",
      "whenTitle": "Ե՞րբ ես տեղափոխվում",
      "packageTitle": "Ի՞նչ է պետք",
      "customTitle": "Նշիր անհրաժեշտ ծառայությունները",
      "errPackage": "Ընտրիր փաթեթը։",
      "errWhen": "Ընտրիր տարբերակ կամ նշիր ամսաթիվը։",
      "errEmpty": "Նշիր գոնե մեկ ծառայություն։",
      "comment": "Մեկնաբանություն",
      "commentHint": "Քանի հոգի եք, կա՞ն երեխաներ կամ կենդանիներ, ինչն է կարևոր",
      "submit": "Ուղարկել պլանը",
      "created": "Պլանն ուղարկված է, օպերատորը շուտով կկապվի",
      "status": {
        "TODO": "սպասում է",
        "IN_PROGRESS": "ընթացքում",
        "DONE": "պատրաստ է",
        "SKIPPED": "պետք չէ"
      }
    },
    "docs": {
      "title": "Փաստաթղթեր",
      "sub": "Ինչ պատրաստել մինչև տեղափոխվելը։ Նշիր, որ ոչինչ չմոռանաս։",
      "progress": "Պատրաստ է {{done}}-ը {{total}}-ից",
      "needPlan": "Նախ հավաքիր տեղափոխության պլանը, հետո նշիր փաստաթղթերը։",
      "ask": "Հարցնել կոնսիերժին"
    },
    "concierge": {
      "title": "Կոնսիերժ",
      "short": "Գրիր չատում՝ կպատասխանենք այնտեղ"
    },
    "request": {
      "title": "Թողնել հայտ",
      "sub": "Օպերատորը կկապվի, կճշտի մանրամասները և կձևակերպի պատվերը։",
      "comment": "Ինչ է պետք անել",
      "commentHint": "Օրինակ՝ խոհանոցի ծորակը կաթում է, հարմար է 18:00-ից հետո",
      "submit": "Ուղարկել հայտը",
      "sentTitle": "Հայտ №{{number}} ուղարկված է",
      "sentText": "Օպերատորը կկապվի աշխատանքային ժամերին։",
      "back": "Դեպի ծառայություններ",
      "yourDiscount": "Բաժանորդագրության զեղչը՝ −{{pct}}%"
    },
    "partners": {
      "howTo": "Ցույց տուր QR-ը դրամարկղում՝ աշխատակիցը կսկանավորի տեսախցիկով։ Կոդը փոխվում է ամեն րոպե, սքրինշոթը չի աշխատի։",
      "cat": {
        "cafe": "Սրճարան",
        "restaurant": "Ռեստորան",
        "shop": "Խանութ",
        "beauty": "Գեղեցկություն",
        "other": "Այլ"
      },
      "qrLabel": "Ակումբի քարտի QR",
      "qrRefresh": "կթարմացվի {{seconds}} վրկ-ից",
      "allMembers": "բոլոր անդամներին",
      "needLevel": "{{level}}-ով",
      "limit_ONCE": "առաջին այց",
      "limit_WEEK": "{{count}}× շաբաթը",
      "limit_MONTH": "{{count}}× ամիսը",
      "used_ONCE": "արդեն ստացել եք",
      "used_WEEK": "կրկին հաջորդ շաբաթից",
      "used_MONTH": "կրկին հաջորդ ամսից"
    },
    "chat": {
      "title": "Զրույց Barev Club-ի հետ",
      "support": "Աջակցություն",
      "concierge": "Անձնական կոնսիերժ",
      "hint": "Սա նույն զրույցն է, ինչ բոտի չատում․ պատասխանը կգա և՛ այստեղ, և՛ Telegram-ում։",
      "empty": "Գրեք, թե ինչով օգնել՝ կպատասխանենք այստեղ։",
      "placeholder": "Հաղորդագրություն…",
      "send": "Ուղարկել",
      "attach": "Կցել լուսանկար կամ ֆայլ",
      "conciergeOnly": "Անձնական կոնսիերժը՝ Barev+ և Barev Elite-ում",
      "team": "Barev Club",
      "fileTooBig": "Ֆայլը 10 ՄԲ-ից մեծ է",
      "file": "Ֆայլ"
    },
    "rate": {
      "title": "Ինչպե՞ս անցավ",
      "text": "Գնահատականը կօգնի մեզ հետևել որակին",
      "comment": "Մեկնաբանություն՝ ըստ ցանկության",
      "send": "Գնահատել",
      "thanks": "Շնորհակալություն գնահատականի համար",
      "yours": "Քո գնահատականը",
      "change": "Փոխել",
      "star": "{{count}}՝ 5-ից",
      "prompt": "Գնահատիր պատվերը"
    },
    "card": {
      "title": "Ակումբային քարտ",
      "partners": "Ակումբի գործընկերներ",
      "plans": "Մակարդակներ և զեղչեր"
    },
    "points": {
      "title": "Բարիկներ",
      "balance": "Հասանելի է",
      "equals": "բարիկ ≈ {{amount}} ֏ · 1 բարիկ = 1 ֏",
      "pending": "սպասման մեջ՝ {{amount}}, հասանելի կլինեն {{date}}",
      "burn": "{{amount}}-ը կայրվի {{date}}․ ցանկացած պատվեր կպահի դրանք",
      "pay": "Վճարել բարիկներով",
      "enterCode": "Մուտքագրել կոդ",
      "requestPending": "Բարիկներով վճարման հայտը սպասում է հաստատման։",
      "rates": "Քեշբեք ըստ կատեգորիաների",
      "plusWouldGet": "Barev+-ով վերջին 30 օրում կունենայիք ևս +{{amount}} բարիկ →",
      "streak": "Մաքրումների շարք",
      "streakLeft": "Եվս {{left}}՝ և մաքրման քեշբեքը +{{bonus}}%։ Ընդմիջումը՝ ոչ ավելի {{days}} օրից։",
      "streakMax": "Առավելագույն շարք՝ +{{bonus}}% քեշբեք ամեն մաքրման համար։",
      "route": "Առաջին ամսվա երթուղի",
      "routeText": "Պատվիրեք 3 տարբեր կատեգորիայի ծառայություններ մինչև {{date}} և ստացեք {{amount}} բարիկ։ Հիմա՝ {{done}}/3։",
      "history": "Պատմություն",
      "empty": "Բարիկներ եք ստանում ամեն վճարված պատվերի համար՝ ձեր մակարդակի տոկոսով։",
      "availableFrom": "հասանելի են {{date}}-ից",
      "until": "մինչև {{date}}",
      "payHint": "Բարիկներով կարելի է վճարել պատվերի մինչև {{pct}}%-ը, նվազագույնը՝ {{min}}։ Թիմը կհաստատի և կուղարկի մնացած գումարը։",
      "forOrder": "Պատվեր",
      "otherOrder": "Այլ պատվեր (հավելվածից դուրս)",
      "amount": "Քանի բարիկ դուրս գրել",
      "max": "Առավելագույնը՝ {{max}}",
      "note": "Մեկնաբանություն",
      "notePh": "Որ պատվերը և ինչ գումարով",
      "send": "Ուղարկել հայտը",
      "requested": "Հայտն ուղարկված է․ կպատասխանենք զրույցում։",
      "useInOrder": "Դուրս գրել {{amount}} բարիկ",
      "useHint": "մինչև պատվերի {{pct}}%-ը · հաշվին՝ {{balance}}",
      "notWithPromo": "Ոչ պրոմոկոդի հետ միասին",
      "belowMin": "Նվազագույնը՝ {{min}} · հաշվին՝ {{balance}}",
      "paidLine": "Վճարված է բարիկներով",
      "type": {
        "accrual": "Քեշբեք",
        "bonus": "Բոնուս",
        "redemption": "Վճարում բարիկներով",
        "request": "Վճարման հայտ",
        "reversal": "Չեղարկում"
      },
      "status": {
        "PENDING": "սպասման մեջ",
        "ACTIVE": "հասանելի",
        "SPENT": "ծախսված",
        "EXPIRED": "այրված",
        "REVERSED": "չեղարկված",
        "REQUESTED": "սպասում է հաստատման",
        "CONFIRMED": "դուրս է գրված",
        "REJECTED": "մերժված",
        "ACCRUAL": "հաշվեգրումը չեղարկված է",
        "REDEMPTION": "բարիկները վերադարձվել են"
      }
    }
  },
  "pro": {
    "nav": {
      "label": "Նավիգացիա",
      "today": "Այսօր",
      "history": "Պատմություն",
      "company": "Ընկերություն",
      "partner": "Գործընկեր"
    },
    "openInTelegram": {
      "title": "Բացեք Telegram-ում",
      "text": "Կատարողի անձնական էջը բացվում է Barev Pro բոտից։"
    },
    "notLinked": {
      "title": "Հաշիվը կապված չէ",
      "text": "Խնդրեք օպերատորից հրավերի հղում և բացեք այն Telegram-ում։"
    },
    "today": {
      "onShift": "Հերթափոխում",
      "offShift": "Հերթափոխից դուրս",
      "earned": "Վաստակ",
      "orders": "Պատվերներ",
      "rating": "Վարկանիշ",
      "now": "Հիմա",
      "open": "Բացել պատվերը",
      "title": "Այսօրվա պատվերները",
      "empty": "Այսօր պատվերներ չկան։",
      "upcoming": "Առաջիկայում"
    },
    "offer": {
      "title": "Նոր պատվեր",
      "accept": "Ընդունել",
      "decline": "Մերժել",
      "accepted": "Պատվերն ընդունված է",
      "declined": "Դուք հրաժարվեցիք պատվերից",
      "left": "մնաց"
    },
    "action": {
      "depart": "Ճանապարհին եմ",
      "arrived": "Տեղում եմ",
      "startCleaning": "Սկսել մաքրումը",
      "finishCleaning": "Ավարտել և ուղարկել լուսանկարներ",
      "startWork": "Սկսել աշխատանքը",
      "closeRepair": "Փակել պատվերը",
      "atPickup": "Օդանավակայանում եմ",
      "passengerIn": "Ուղևորը մեքենայում է",
      "finishRide": "Ավարտել ուղևորությունը",
      "scheduleLesson": "Նշանակել դաս",
      "openLesson": "Բացել դասը",
      "startLesson": "Սկսել",
      "finishLesson": "Ավարտել դասը",
      "openMeeting": "Բացել հանդիպումը",
      "startMeeting": "Սկսել",
      "finishMeeting": "Ավարտել"
    },
    "job": {
      "when": "Երբ",
      "where": "Որտեղ",
      "client": "Հաճախորդ",
      "clientLanguage": "լեզու",
      "price": "Գումար",
      "checklist": "Ստուգաթերթ",
      "checklistFirst": "Ավարտելու համար նշեք ստուգաթերթի բոլոր կետերը և կցեք լուսանկար։",
      "takePhoto": "Լուսանկարել",
      "retakePhoto": "Նորից լուսանկարել",
      "confirmFinish": "Ավարտե՞լ պատվերը։ Հաճախորդը կստանա ծանուցում և լուսանկարային հաշվետվություն։",
      "markPaid": "Հաճախորդը վճարել է",
      "confirmPaid": "Հաստատե՞լ, որ հաճախորդը վճարել է {{amount}}։",
      "paidMarked": "Վճարումը նշված է"
    },
    "history": {
      "title": "Պատմություն",
      "week": "7 օր",
      "month": "Այս ամիս",
      "prevMonth": "Նախորդ ամիս",
      "earned": "Վաստակած",
      "done": "Կատարված",
      "empty": "Այս ժամանակահատվածում պատվերներ չկան։",
      "ratePercent": "Դրույք՝ պատվերի {{value}}%",
      "rateFixed": "Դրույք՝ {{value}} մեկ պատվերի համար",
      "ratePreset": "Դրույք՝ «{{name}}» նախադրվածք",
      "ratePartner": "Պատվերների վարձատրությունը սահմանում է ձեր ընկերությունը"
    },
    "company": {
      "title": "Ընկերություն",
      "pending": "Սպասում են բաշխման",
      "noPending": "Բոլոր պատվերները բաշխված են։",
      "assign": "Նշանակել աշխատակցի",
      "chooseStaff": "Ում հանձնել պատվերը",
      "assigned": "Նշանակված",
      "noAssigned": "Դեռ դատարկ է։",
      "assigned_ok": "Աշխատակիցը նշանակված է",
      "staff": "Աշխատակիցներ",
      "notLinked": "բոտում չէ",
      "free": "ազատ է",
      "busy": "զբաղված է",
      "speaksLanguage": "հաճախորդի լեզուն",
      "load_one": "{{count}} պատվեր այդ օրը",
      "load_few": "{{count}} պատվեր այդ օրը",
      "load_many": "{{count}} պատվեր այդ օրը",
      "load_other": "{{count}} պատվեր այդ օրը"
    },
    "partner": {
      "owner": "սեփականատեր",
      "staff": "աշխատակից",
      "visits30_one": "{{count}} ստուգում 30 օրում",
      "visits30_few": "{{count}} ստուգում 30 օրում",
      "visits30_many": "{{count}} ստուգում 30 օրում",
      "visits30_other": "{{count}} ստուգում 30 օրում",
      "scan": "Սկանավորել հաճախորդի QR-ը",
      "scanSub": "Ցույց կտա հաճախորդի մակարդակը և ինչ է նրան հասնում",
      "scanHint": "Ուղղեք տեսախցիկը հաճախորդի հավելվածի QR-ին",
      "noScanner": "Սկաները աշխատում է միայն Telegram-ում։ Կարող եք մուտքագրել կոդը ձեռքով։",
      "manual": "Կամ տեղադրեք QR-ի կոդը / հղումը",
      "check": "Ստուգել",
      "valid": "{{name}} — {{level}}",
      "until": "բաժանորդագրությունը մինչև {{date}}",
      "needLevel": "պետք է {{level}}",
      "unlimited": "առանց սահմանափակման",
      "redeemed": "Դուրս գրված է՝ {{offer}}",
      "offers": "Ձեր առաջարկները ակումբի համար",
      "noOffers": "Առաջարկներ դեռ չկան։",
      "offersHint": "Առաջարկները փոխելու համար գրեք ակումբի օպերատորին։",
      "allMembers": "բոլոր անդամներին",
      "limit_ONCE": "միայն առաջին այցը",
      "limit_WEEK": "{{count}}× շաբաթը",
      "limit_MONTH": "{{count}}× ամիսը",
      "team": "Աշխատակիցներ",
      "invite": "Հրավիրել",
      "inviteQr": "Աշխատակցի հրավերի QR",
      "inviteHint": "Աշխատակիցը սկանավորում է այս QR-ը հեռախոսի տեսախցիկով և սեղմում Start։ Մեկանգամյա է, գործում է մինչև {{time}}։",
      "inviteLink": "Կամ ուղարկեք հղումը",
      "remove": "Հեռացնել",
      "removeConfirm": "Հեռացնե՞լ {{name}}-ին աշխատակիցներից",
      "recent": "Վերջին ստուգումները",
      "noRecent": "Ստուգումներ դեռ չեն եղել։",
      "checked": "քարտի ստուգում"
    },
    "web": {
      "loginHint": "Բացեք աշխատանքային բոտը և սեղմեք «Բացել համակարգչում» (կամ ուղարկեք /web)՝ կստանաք մուտքի հղում։"
    },
    "cab": {
      "tab": {
        "orders": "Պատվերներ",
        "staff": "Աշխատակիցներ",
        "money": "Եկամուտ",
        "settings": "Կարգավորումներ"
      },
      "autoOn": "Ավտոբաշխումը միացված է․ նոր պատվերներն ինքնաբերաբար գնում են ազատ աշխատակիցներին։",
      "income": "Ձեր եկամուտը",
      "deadline": "նշանակեք մինչև {{time}}",
      "offeredTo": "սպասում ենք՝ {{name}}",
      "decline": "Հրաժարվել",
      "declineConfirm": "Հրաժարվե՞լ պատվերից։ Այն կվերադառնա Barev Club։",
      "declined": "Պատվերը վերադարձված է",
      "reassign": "Վերանշանակել",
      "unassignConfirm": "Հանե՞լ {{name}}-ին պատվերից։ Պատվերը նորից կսպասի նշանակման։",
      "unassigned": "Աշխատակիցը հանված է",
      "gapHint": "Ճանապարհի ընդմիջում պատվերների միջև՝ {{min}} րոպե։",
      "noStaff": "Աշխատակիցներ դեռ չկան․ ավելացրեք «Աշխատակիցներ» բաժնում։",
      "dayLoad": "այդ օրը՝ {{n}}/{{max}}",
      "weekLoad": "շաբաթում՝ {{n}}",
      "district": "շրջան",
      "check": {
        "ok": "Ազատ",
        "busy": "Զբաղված",
        "gap": "Չի հասցնի",
        "limit": "Օրական սահմանաչափ",
        "notLinked": "Բոտ չի մտել",
        "gap_confirm": "Պատվերների միջև ճանապարհի ժամանակը սահմանվածից քիչ է։ Միևնույն է նշանակե՞լ։",
        "limit_confirm": "Աշխատակիցն այդ օրվա պատվերների կամ ժամերի սահմանաչափին է հասել։ Միևնույն է նշանակե՞լ։",
        "notLinked_confirm": "Աշխատակիցը դեռ չի մտել աշխատանքային բոտ և ծանուցում չի ստանա։ Նշանակե՞լ։",
        "busy_confirm": "Աշխատակիցն այդ ժամին զբաղված է։"
      },
      "addStaff": "Ավելացնել աշխատակից",
      "todayLoad": "այսօր՝ {{n}}/{{max}}",
      "hoursMax": "օրական մինչև {{n}} ժ",
      "off": "անջատված",
      "staffAdded": "Աշխատակիցն ավելացված է",
      "saved": "Պահպանված է",
      "inviteText": "Ուղարկեք այս հղումը աշխատակցին․ նա կբացի աշխատանքային բոտը և կկարողանա ընդունել պատվերներ։",
      "done": "Պատրաստ է",
      "f": {
        "name": "Անուն",
        "phone": "Հեռախոս",
        "languages": "Լեզուներ",
        "districts": "Շրջաններ (դատարկ՝ ցանկացած)",
        "days": "Աշխատանքային օրեր",
        "from": "Սկսած",
        "to": "Մինչև",
        "maxOrders": "Օրական պատվերներ, առավ.",
        "maxHours": "Օրական ժամեր, առավ.",
        "loadHint": "Դատարկ՝ առանց սահմանաչափի։ Ավտոբաշխումն ավելին չի տա։"
      },
      "save": "Պահպանել",
      "resetInvite": "Մուտքի նոր հղում",
      "resetConfirm": "Ստեղծե՞լ նոր հղում։ Ընթացիկ մուտքը բոտ կանջատվի։",
      "turnOff": "Անջատել",
      "turnOn": "Միացնել",
      "offConfirm": "Անջատե՞լ {{name}}-ին։ Նոր պատվերներ չի ստանա։",
      "copy": "Պատճենել",
      "copied": "Պատճենված է",
      "balance": "Վճարման ենթակա",
      "accrued": "Հաշվեգրված",
      "paidOut": "Վճարված",
      "terms": {
        "COMMISSION": "Պայմաններ․ Barev Club-ը վերցնում է վճարված պատվերի {{pct}}%-ը, մնացածը ձերն է։ Աշխատավարձն ու ծախսերը ձեզ վրա են։",
        "PROFIT_SHARE": "Պայմաններ․ մաքրողի աշխատավարձը ({{fot}}%) և հարկը ({{tax}}%) վճարում է Barev Club-ը, ձեզ՝ մնացորդի {{pct}}%-ը։"
      },
      "byMonth": "Ըստ ամիսների",
      "ordersN": "պատվերներ՝ {{n}}",
      "byOrder": "Ըստ պատվերների",
      "noIncome": "Եկամուտը կհայտնվի, երբ հաճախորդը վճարի կատարված պատվերի համար։",
      "paidBy": "վճարված՝ {{sum}}",
      "minus": "−աշխ. {{fot}}, −հարկ {{tax}}, ձեր {{pct}}%",
      "minusCommission": "−{{pct}}% Barev Club",
      "payouts": "Վճարումներ",
      "payout": {
        "paid": "վճարված",
        "pending": "սպասում է"
      },
      "auto": "Ավտոբաշխում",
      "autoHint": "Նոր պատվերն առաջարկվում է լավագույն ազատ աշխատակցին՝ ազատ է ըստ գրաֆիկի, հասցնում է տեղ հասնել, սահմանաչափը չի գերազանցված․ նախապատվությունը՝ ով գիտի հաճախորդի լեզուն, աշխատում է շրջանում, ունի քիչ պատվեր շաբաթում և բարձր վարկանիշ։ Հրաժարվեց կամ չպատասխանեց՝ հաջորդին։",
      "gap": "Ճանապարհի ընդմիջում պատվերների միջև, րոպե",
      "gapMin": "Առնվազն {{min}} րոպե",
      "timeoutHint": "Եթե պատվերը {{min}} րոպեում չնշանակվի, այն կվերադառնա Barev Club։",
      "managers": "Մենեջերներ",
      "you": "դուք",
      "remove": "Հեռացնել",
      "removeManagerConfirm": "Հեռացնե՞լ {{name}}-ին մենեջերներից։",
      "managerInvite": "Հղում ևս մեկ մենեջերի համար․ նա կբացի աշխատանքային բոտը և մուտք կստանա կաբինետ․",
      "logout": "Ելք այս համակարգչում",
      "wd": {
        "0": "Երկ",
        "1": "Երք",
        "2": "Չրք",
        "3": "Հնգ",
        "4": "Ուրբ",
        "5": "Շբթ",
        "6": "Կիր"
      }
    }
  },
  "bot": {
    "client": {
      "chooseLanguage": "Выбери язык · Choose your language · 选择语言 · Ընտրեք լեզուն · Elige tu idioma",
      "languageSet": "Լեզու՝ {{language}}",
      "fromAgency": "Բարև՛։ Դուք եկել եք {{agency}} անշարժ գույքի գործակալությունից՝ ձեզ համար նվեր ունենք։",
      "consentText": "Barev Club-ից օգտվելու համար անհրաժեշտ է անձնական տվյալների մշակման համաձայնություն։ Տվյալները ստանում են ձեր պատվերի կատարողը և քաղաքականությունում նշված գործընկերները, իսկ պահվում են Գերմանիայում գտնվող սերվերում։\n\n<a href=\"{{url}}\">Գաղտնիության քաղաքականություն</a>",
      "consentAccept": "Համաձայն եմ",
      "giftActivated": "🎁 Նվեր անշարժ գույքի գործակալությունից՝ {{plan}}-ն ակտիվ է մինչև {{date}}։ Զեղչերն արդեն կիրառվում են։",
      "welcome": "Երևանը՝ ինչպես տանը։ Առաջին օրվանից։\n\nՊատվիրեք մաքրում և այլ ծառայություններ, հետևեք կարգավիճակին և օգտվեք գործընկերների զեղչերից՝ ամեն ինչ հավելվածում։",
      "openApp": "Բացել հավելվածը",
      "enterCode": "Մուտքագրել գործակալության կոդը",
      "changeLanguage": "Փոխել լեզուն",
      "codePrompt": "Ուղարկեք անշարժ գույքի գործակալության կոդը վարձակալության պայմանագրից։",
      "codeAccepted": "Կոդն ընդունված է՝ {{agency}}։",
      "help": "Ծառայություն պատվիրելու համար սեղմեք «Բացել հավելվածը»։ Հրամաններ՝ /app — հավելված, /code — անշարժ գույքի գործակալության կոդ, /language — լեզու։",
      "cmdStart": "Սկսել",
      "cmdApp": "Բացել հավելվածը",
      "cmdCode": "Մուտքագրել գործակալության կոդը",
      "cmdLanguage": "Փոխել լեզուն",
      "cmdHelp": "Օգնություն",
      "webRequestOrdered": "Հայտ №{{request}}-ն ընդունված է և ձևակերպված որպես պատվեր №{{order}}՝ {{date}}։ Կարգավիճակը՝ հավելվածում։",
      "webRequestLinked": "Հայտ №{{request}}-ն ընդունված է։ Օպերատորը կկապվի քեզ հետ և կհաստատի ժամը։",
      "conciergeReceived": "Փոխանցեցինք կոնսիերժին՝ կպատասխանենք այստեղ, այս չատում։",
      "supportReceived": "Փոխանցեցինք աջակցությանը՝ կպատասխանենք այստեղ, այս չատում։",
      "channelSupport": "Այժմ գրում եք աջակցությանը։ Պարզապես ուղարկեք հաղորդագրություն, լուսանկար կամ ֆայլ։",
      "channelConcierge": "Այժմ գրում եք ձեր անձնական կոնսիերժին։ Պարզապես ուղարկեք հաղորդագրություն, լուսանկար կամ ֆայլ։",
      "cmdSupport": "Գրել աջակցությանը",
      "cmdConcierge": "Գրել կոնսիերժին (Barev+)",
      "rated": "Շնորհակալություն գնահատականի համար։ {{stars}}",
      "ratedLow": "Ափսոս, որ ամեն ինչ լավ չանցավ։ Գրիր այստեղ, թե ինչ է պատահել, թիմը կզբաղվի։",
      "wr": {
        "intro": "Ձեր №{{request}} հայտը ստացել ենք։ Մնաց մի քանի հարց՝ պատվերը ձևակերպելու համար։",
        "askDistrict": "Ո՞ր վարչական շրջանում է բնակարանը։",
        "askAddress": "Գրեք հասցեն՝ փողոց, շենք, բնակարան։",
        "askDay": "Ե՞րբ է հարմար։ Ընտրեք օրը։",
        "askTime": "Ընտրեք ժամը՝ {{day}}․",
        "dayFull": "Այդ օրն արդեն զբաղված է։ Ընտրեք այլ օր։",
        "noSlots": "Մոտակա օրերին ազատ ժամ չկա․ օպերատորը կկապվի ձեզ հետ և կընտրի ժամը։"
      },
      "cmdBalance": "Բարիկների մնացորդ",
      "cmdHistory": "Բարիկների պատմություն",
      "points": {
        "balance": "🪙 Բարիկներ՝ {{balance}} (≈ {{balance}} ֏)",
        "pending": "⏳ Սպասման մեջ՝ {{pending}}, հասանելի կլինեն {{date}}",
        "burn": "🔥 Կայրվեն {{date}}, եթե պատվերներ չլինեն",
        "empty": "Բարիկներով գործողություններ դեռ չկան։",
        "open": "Բացել բարիկները",
        "type": {
          "accrual": "Քեշբեք",
          "bonus": "Բոնուս",
          "redemption": "Վճարում բարիկներով",
          "request": "Վճարման հայտ",
          "reversal": "Չեղարկում"
        },
        "status": {
          "PENDING": "սպասման մեջ",
          "ACTIVE": "հասանելի",
          "SPENT": "ծախսված",
          "EXPIRED": "այրված",
          "REVERSED": "չեղարկված",
          "REQUESTED": "սպասում է հաստատման",
          "CONFIRMED": "դուրս է գրված",
          "REJECTED": "մերժված",
          "ACCRUAL": "հաշվեգրումը չեղարկված է",
          "REDEMPTION": "բարիկները վերադարձվել են"
        }
      }
    },
    "pro": {
      "notLinked": "Այս բոտը Barev Club-ի կատարողների համար է։ Խնդրեք օպերատորից հրավերի հղում։",
      "linkedProvider": "Պատրաստ է, {{name}}։ Հաշիվը կապված է։",
      "linkedDispatcher": "Պատրաստ է։ Դուք «{{name}}» ընկերության դիսպետչերն եք։",
      "youAreProvider": "{{name}} · {{role}}",
      "youAreDispatcher": "«{{company}}» ընկերության դիսպետչեր",
      "welcome": "Այստեղ գալիս են նոր պատվերները։ Ընդունեք դրանք հաղորդագրության կոճակներով, իսկ օրվա պատվերները վարեք անձնական էջում։",
      "openCabinet": "Բացել անձնական էջը",
      "messageReceived": "Փոխանցեցինք օպերատորին՝ պատասխանը կգա այստեղ։",
      "openWeb": "💻 Բացել համակարգչում",
      "webLink": "Կաբինետի հղումը բրաուզերի համար (մեկանգամյա, գործում է 15 րոպե)․\n{{url}}"
    },
    "admin": {
      "hello": "{{name}}, այստեղ գալիս են Barev Club ադմինկայի ծանուցումները։",
      "linked": "Պատրաստ է, {{name}}։ Ադմինկայի ծանուցումները կգան այստեղ։ Հաճախորդներին պատասխանեք «Պատասխանել» կոճակով։",
      "linkInvalid": "Հղումը հնացել է՝ կրկին սեղմեք «Միացնել Telegram» ադմինկայում։",
      "notAdmin": "Այս Telegram-ը միացված չէ ադմինկային։",
      "open": "Բացել ադմինկայում",
      "reply": "Պատասխանել",
      "replyPrompt": "Պատասխան {{name}}-ին՝ գրեք հաղորդագրությամբ։ /cancel՝ չեղարկել։",
      "replyPlaceholder": "Պատասխանի տեքստ",
      "replySent": "Ուղարկված է՝ {{name}}",
      "replyCancelled": "Պատասխանը չեղարկված է։",
      "provider": "կատարող",
      "newOrder": "Նոր պատվեր #{{number}}",
      "newLead": "Տեղափոխության հայտ №{{number}}",
      "newRequest": "Հայտ հավելվածից №{{number}}",
      "newWebRequest": "Հայտ կայքից №{{number}}",
      "loginOk": "Մուտքը հաստատված է — վերադարձեք բրաուզեր։",
      "loginExpired": "Մուտքի հղումը հնացել է — թարմացրեք ադմին էջը։",
      "channelSupport": "Աջակցություն",
      "channelConcierge": "Կոնսիերժ",
      "file": "ֆայլ",
      "chatAssigned": "{{by}}-ը ձեզ փոխանցեց զրույցը՝ {{name}}",
      "order": "Պատվեր №{{number}}",
      "noOrder": "Այժմ պատվեր չկա",
      "autoFailed": "№{{number}} պատվերի համար ազատ կատարող չգտնվեց․ նշանակեք ձեռքով։",
      "partnerDeclined": "«{{partner}}» գործընկերը հրաժարվեց №{{number}} պատվերից․ նշանակեք նորից",
      "partnerExpired": "«{{partner}}» գործընկերը ժամանակին աշխատակից չնշանակեց №{{number}} պատվերին․ նշանակեք նորից",
      "noTime": "ժամը նշված չէ",
      "noAddress": "հասցեն նշված չէ",
      "points": {
        "forOrder": "Order #{{number}} for {{sum}}",
        "confirm": "✅ Confirm",
        "reject": "Decline",
        "request": "Client asks to pay with bariki: {{amount}}",
        "balance": "balance {{balance}}",
        "suggestions": "New bariki suggestions: {{count}} ({{open}} in the queue)",
        "overLimit": "{{by}} wants to process {{amount}} bariki — above the limit, needs your approval",
        "mismatch": "Bariki reconciliation: {{count}} clients had a mismatched balance — fixed, check the log",
        "confirmed": "Redeemed {{amount}} bariki",
        "rejected": "Request declined",
        "help": "Credit for an order: /barik <phone or @username> <order amount> [category]\nCategories: cleaning, documents, learning, repair, transfer",
        "noClient": "Client not found",
        "preview": "Credit {{amount}} bariki to {{name}} for {{what}} {{sum}} ֏ ({{tier}}, {{rate}}%). Available from {{date}}.",
        "accrue": "🪙 Credit",
        "done": "Credited {{amount}} bariki",
        "needsApproval": "Above the limit — sent to a super admin for approval",
        "zero": "The amount is 0 — nothing to credit"
      },
      "pay": {
        "subscription": "{{plan}} բաժանորդագրություն",
        "order": "Պատվեր #{{number}} · {{service}}",
        "paid": "Առցանց վճարում",
        "renewed": "Բաժանորդագրության երկարաձգում",
        "refunded": "Առցանց վճարման վերադարձ",
        "cancelled": "Ավտոերկարաձգումը դադարեցված է",
        "attention": "Վճարումը ուշադրություն է պահանջում",
        "attentionHint": "Հաճախորդը վճարել է առցանց, բայց պատվերն արդեն վճարված կամ չեղարկված է — անհրաժեշտ է վերադարձ Tribute-ում։",
        "fromSite": "Վճարված կայքում (Telegram-ը դեռ կապված չէ)"
      }
    },
    "partner": {
      "valid": "{{name}} — {{level}}, քարտը գործում է",
      "until": "բաժանորդագրությունը մինչև {{date}}",
      "needLevel": "պետք է {{level}}",
      "noOffers": "Առաջարկներ դեռ չկան՝ գրեք ակումբի օպերատորին։",
      "notPartner": "Սա Barev Club-ի քարտ է։ Ստուգել կարող է միայն ակումբի գործընկերը։",
      "redeem": "Դուրս գրել",
      "redeemed": "Դուրս գրված է",
      "redeemedText": "Դուրս գրված է՝ {{offer}}",
      "linkedOwner": "Պատրաստ է։ Դուք «{{partner}}»-ի սեփականատերն եք։ Բացեք կաբինետը՝ առաջարկներ, աշխատակիցներ և QR սկաներ։",
      "linkedStaff": "Պատրաստ է։ Դուք «{{partner}}»-ի աշխատակից եք։ Սկանավորեք հաճախորդների QR-ը տեսախցիկով կամ կաբինետում։",
      "youAreOwner": "«{{partner}}»-ի սեփականատեր",
      "youAreStaff": "«{{partner}}»-ի աշխատակից",
      "left_ONCE": "առաջին այց",
      "left_WEEK": "այս շաբաթ մնացել է՝ {{count}}",
      "left_MONTH": "այս ամիս մնացել է՝ {{count}}",
      "used_ONCE": "արդեն օգտագործված է",
      "used_WEEK": "այս շաբաթ արդեն օգտագործված է",
      "used_MONTH": "այս ամիս արդեն օգտագործված է"
    }
  },
  "notify": {
    "openOrder": "Բացել պատվերը",
    "duration": "{{minutes}} րոպե",
    "clientLanguage": "Հաճախորդի լեզուն",
    "created": "Պատվերն ընդունված է՝ {{when}}։ Ընդամենը {{total}}։ Կտեղեկացնենք, երբ կատարող նշանակենք։",
    "rescheduled": "Պատվերը տեղափոխված է՝ {{when}}։",
    "reminder24": "Հիշեցում՝ վաղը, {{when}}։",
    "reminder1": "Մեկ ժամից՝ {{when}}։",
    "event": {
      "arrived": "Կատարողը տեղում է։",
      "openLesson": "Դասը շուտով կսկսվի։",
      "openMeeting": "Հանդիպումը շուտով կսկսվի։"
    },
    "status": {
      "CLEANING": {
        "NEW": "Փնտրում ենք նոր մաքրող՝ {{when}}։",
        "ASSIGNED": "{{provider}}-ը նշանակված է մաքրման՝ {{when}}։",
        "EN_ROUTE": "{{provider}}-ն արդեն ճանապարհին է։",
        "CLEANING": "Մաքրումը սկսվել է։",
        "DONE": "Մաքրումն ավարտված է։ Լուսանկարային հաշվետվությունը հավելվածում է։",
        "CANCELLED": "Պատվերը չեղարկված է։"
      },
      "REPAIR": {
        "NEW": "Փնտրում ենք վարպետ՝ {{when}}։",
        "ASSIGNED": "Վարպետ {{provider}}-ը նշանակված է՝ {{when}}։",
        "ON_SITE": "Վարպետը տեղում է և պատրաստում է նախահաշիվը։",
        "ESTIMATE_APPROVED": "Նախահաշիվը համաձայնեցված է։",
        "REPAIRING": "Վերանորոգումը սկսվել է։",
        "DONE": "Վերանորոգումն ավարտված է։",
        "CANCELLED": "Պատվերը չեղարկված է։"
      },
      "TRANSFER": {
        "NEW": "Փնտրում ենք վարորդ՝ {{when}}։",
        "ASSIGNED": "Վարորդ {{provider}}-ը նշանակված է՝ {{when}}։",
        "DRIVER_WAITING": "Վարորդը ձեզ սպասում է։",
        "RIDE_IN_PROGRESS": "Ուղևորությունը սկսվել է։",
        "COMPLETED": "Ուղևորությունն ավարտված է։",
        "CANCELLED": "Պատվերը չեղարկված է։"
      },
      "LANGUAGE": {
        "ENROLLED": "Դուք գրանցված եք դասընթացին։",
        "LESSON_SCHEDULED": "Դասը նշանակված է՝ {{when}}։",
        "LESSON_IN_PROGRESS": "Դասը սկսվել է։",
        "LESSON_DONE": "Դասն ավարտված է։",
        "COMPLETED": "Դասերի փաթեթն անցած է։",
        "CANCELLED": "Պատվերը չեղարկված է։"
      },
      "CAREER": {
        "NEW": "Փնտրում ենք խորհրդատու։",
        "CONSULTANT_ASSIGNED": "Խորհրդատու {{provider}}-ը նշանակված է։",
        "RESUME_RECEIVED": "Ինքնակենսագրությունը ստացված է։",
        "MEETING": "Հանդիպումը սկսվել է։",
        "PLAN_SENT": "Աշխատանքի որոնման պլանը պատրաստ է։",
        "CANCELLED": "Պատվերը չեղարկված է։"
      },
      "DOCUMENTS": {
        "NEW": "Հայտն ընդունված է։",
        "DOCS_REVIEW": "Ստուգում ենք փաստաթղթերը։",
        "NEEDS_MORE_DOCS": "Անհրաժեշտ են լրացուցիչ փաստաթղթեր՝ մանրամասները հավելվածում։",
        "SUBMITTED": "Փաստաթղթերը ներկայացված են։",
        "DONE": "Փաստաթուղթը պատրաստ է։",
        "CANCELLED": "Պատվերը չեղարկված է։"
      }
    },
    "pro": {
      "offerTitle": "Նոր պատվեր ձեզ համար",
      "offerTimeout": "Պատասխանեք {{minutes}} րոպեի ընթացքում, այլապես պատվերը կանցնի այլ կատարողի։",
      "assignedByDispatcher": "Դիսպետչերը ձեզ նշանակել է պատվեր՝ {{when}}։",
      "cancelled": "{{when}}-ի պատվերը չեղարկվել է։",
      "rescheduled": "Պատվերը տեղափոխված է՝ {{when}}։",
      "unassigned": "{{when}}-ի պատվերը հանվել է ձեզնից։",
      "reminder24": "Վաղը պատվեր՝ {{when}}։",
      "reminder1": "Մեկ ժամից պատվեր՝ {{when}}։",
      "orderEdited": "{{when}} պատվերը փոխվել է․ բացեք այն։"
    },
    "dispatcher": {
      "newOrder": "Նոր պատվեր ընկերության համար՝ {{when}}։ Նշանակեք աշխատակցի անձնական էջում։",
      "returned": "Աշխատակիցը հրաժարվեց {{when}}-ի պատվերից։ Նշանակեք մեկ ուրիշին։",
      "noStaff": "{{when}} պատվերի համար ազատ աշխատակից չկա․ նշանակեք ձեռքով կաբինետում։",
      "expired": "{{when}} պատվերը վերադարձավ Barev Club՝ աշխատակից ժամանակին չնշանակվեց։"
    },
    "openPlan": "Բացել հավելվածը",
    "concierge": "Barev Club կոնսիերժ",
    "subscriptionActivated": "{{plan}}-ը միացված է մինչև {{date}}։ Զեղչերն արդեն ծառայությունների գներում են։",
    "operator": "Barev Club օպերատոր",
    "support": "Barev Club աջակցություն",
    "rateAsk": "Ինչպե՞ս անցավ։ Խնդրում ենք գնահատել՝ մեկ վայրկյան է։",
    "points": {
      "open": "Իմ բարիկները",
      "pending": "🪙 +{{amount}} բարիկ՝ {{what}}, {{date}}։ Հասանելի կլինեն {{available}}։",
      "active": "🪙 +{{amount}} բարիկ՝ {{what}}։ Մնացորդ՝ {{balance}}։",
      "bonus": "🎁 +{{amount}} բարիկ նվեր՝ {{what}}։ Գործում են մինչև {{until}}։",
      "bonusNoTtl": "🎁 +{{amount}} բարիկ նվեր՝ {{what}}։",
      "housewarming": "բնակարանամուտի առթիվ {{agency}}-ից",
      "activated": "✅ {{amount}} բարիկ հասանելի է։ Մնացորդ՝ {{balance}}։",
      "redeemed": "Վճարված է բարիկներով՝ {{amount}}։ Մնաց վճարել՝ {{due}}։ Մնացորդ՝ {{balance}}։",
      "redeemedNoOrder": "Դուրս է գրվել՝ {{amount}} բարիկ։ Մնացորդ՝ {{balance}}։",
      "requestExpired": "Բարիկներով վճարման հայտի ժամկետը լրացել է։ Անհրաժեշտության դեպքում ուղարկեք նորը։",
      "rejected": "Բարիկներով վճարման հայտը մերժվել է․ {{reason}}",
      "declinedGeneric": "գրեք մեզ զրույցում, կքննարկենք։",
      "orderCancelled": "պատվերը չեղարկվել է",
      "returned": "↩️ {{amount}} բարիկը վերադարձվել է հաշվին։ Մնացորդ՝ {{balance}}։",
      "reversed": "{{what}} հաշվեգրումը չեղարկվել է․ {{reason}}։ Մնացորդ՝ {{balance}}։",
      "expiring": "⏰ {{days}} օրից կայրվի {{amount}} բարիկ։ Ցանկացած պատվեր կպահի դրանք։",
      "expired": "{{amount}} բարիկ այրվեց՝ երկար ժամանակ պատվերներ չկային։",
      "orderEdited": "պատվերը փոխվել է․ կհաշվեգրենք նոր գումարով"
    },
    "orderEdited": "Պատվերը փոխվել է։ Վճարման ենթակա՝ {{total}}։"
  },
  "admin": {
    "nav": {
      "orders": "Պատվերներ",
      "clients": "Հաճախորդներ",
      "providers": "Կատարողներ",
      "companies": "Ծառայությունների գործընկերներ",
      "services": "Ծառայություններ և գներ",
      "agencies": "Անշարժ գույքի գործակալություններ",
      "settings": "Կարգավորումներ",
      "presets": "Դրույքներ",
      "webRequests": "Կայքի հայտեր",
      "leads": "Տեղափոխություն",
      "concierge": "Կոնսիերժ",
      "requests": "Հայտեր հավելվածից",
      "partners": "Ակումբի գործընկերներ",
      "telegram": "Ծանուցումներ",
      "templates": "Տեղափոխության ձևանմուշներ"
    },
    "roles": {
      "OWNER": "Սեփականատեր",
      "OPERATOR": "Օպերատոր"
    },
    "logout": "Ելք",
    "save": "Պահպանել",
    "saved": "Պահպանված է",
    "edit": "Խմբագրել",
    "add": "Ավելացնել",
    "active": "Ակտիվ",
    "copy": "Պատճենել",
    "copied": "Պատճենված է",
    "login": {
      "title": "Մուտք ադմինկա",
      "email": "Մուտքանուն կամ email",
      "password": "Գաղտնաբառ",
      "submit": "Մուտք",
      "totpTitle": "Հաստատման կոդ",
      "setupTitle": "2FA-ի կարգավորում",
      "setupText": "Սկանավորեք QR-կոդը նույնականացման հավելվածով (Google Authenticator, 1Password) և մուտքագրեք կոդը։",
      "qrAlt": "QR-կոդ նույնականացման հավելվածի համար",
      "code": "Կոդ հավելվածից",
      "verify": "Հաստատել"
    },
    "summary": {
      "ordersToday": "Այսօրվա պատվերներ",
      "unassigned": "Առանց կատարողի",
      "revenueToday": "Օրվա հասույթ",
      "freeProviders": "Ազատ / հերթափոխում"
    },
    "kanban": {
      "title": "Պատվերներ",
      "category": "Ուղղություն",
      "allCategories": "Բոլոր ուղղությունները",
      "service": "Ծառայություն",
      "allServices": "Բոլոր ծառայությունները",
      "date": "Ամսաթիվ",
      "search": "Որոնում՝ №, անուն, հասցե",
      "showCancelled": "Չեղարկված",
      "newOrderTitle": "Նոր պատվեր",
      "awaiting": "Սպասում է պատասխանի՝ {{name}}",
      "toCompany": "Նշանակված է ընկերությանը՝ {{name}}",
      "col": {
        "new": "Նոր",
        "assigned": "Նշանակված",
        "in_progress": "Ընթացքում",
        "done": "Պատրաստ",
        "cancelled": "Չեղարկված"
      }
    },
    "order": {
      "when": "Երբ",
      "min": "րոպե",
      "params": "Պարամետրեր",
      "address": "Հասցե",
      "note": "Նշում",
      "client": "Հաճախորդ",
      "agency": "գործակալություն",
      "provider": "Կատարող",
      "price": "Գին",
      "cancelFee": "պահում",
      "payment": "Վճարում",
      "actions": "Գործողություններ",
      "comment": "Մեկնաբանություն գործողությանը",
      "unassign": "Հանել կատարողին",
      "confirmUnassign": "Հանե՞լ կատարողին։ Պատվերը կվերադառնա «Նոր»։",
      "markPaid": "Նշել վճարումը",
      "confirmPaid": "Նշե՞լ, որ ստացվել է {{amount}}։",
      "cancel": "Չեղարկել պատվերը",
      "confirmCancel": "Չեղարկե՞լ պատվերը։ Հաճախորդը ծանուցում կստանա։",
      "checklist": "Ստուգաթերթ",
      "photo": "Լուսանկար",
      "history": "Պատմություն",
      "offers": "Առաջարկներ",
      "assignTitle": "Նշանակում",
      "assignTo": "Նշանակել՝ {{name}}",
      "assign": "Նշանակել",
      "company": "ընկերություն",
      "noCandidates": "Այդ ժամին ազատ կատարողներ չկան։",
      "chooseManually": "Ընտրել ձեռքով ({{count}})",
      "hideOthers": "Թաքցնել",
      "busy": "Զբաղված",
      "load_one": "{{count}} պատվեր այդ օրը",
      "load_few": "{{count}} պատվեր այդ օրը",
      "load_many": "{{count}} պատվեր այդ օրը",
      "load_other": "{{count}} պատվեր այդ օրը",
      "offered": "Պատվերն ուղարկված է կատարողին",
      "statusChanged": "Կարգավիճակը փոխված է",
      "cancelled": "Պատվերը չեղարկված է",
      "unassigned": "Կատարողը հանված է",
      "paid": "Վճարումը նշված է"
    },
    "reasons": {
      "language": "հաճախորդի լեզուն",
      "district": "շրջան",
      "onShift": "հերթափոխում",
      "lowLoad": "ազատ օր"
    },
    "actors": {
      "CLIENT": "հաճախորդ",
      "PROVIDER": "կատարող",
      "DISPATCHER": "դիսպետչեր",
      "ADMIN": "օպերատոր",
      "SYSTEM": "համակարգ"
    },
    "offerStatus": {
      "OFFERED": "սպասում է պատասխանի",
      "ACCEPTED": "ընդունված",
      "DECLINED": "մերժված",
      "EXPIRED": "ժամկետանց",
      "REVOKED": "հետ կանչված"
    },
    "events": {
      "accepted": "Կատարողն ընդունեց պատվերը",
      "dispatcherAssigned": "Դիսպետչերը նշանակեց աշխատակցի",
      "assignedToCompany": "Հանձնված է ընկերությանը",
      "offerDeclined": "Կատարողը հրաժարվեց",
      "offerExpired": "Պատասխանի ժամկետն անցավ",
      "rescheduled": "Տեղափոխում",
      "unassigned": "Կատարողը հանված է",
      "depart": "Ճանապարհին է",
      "arrived": "Տեղում է",
      "startCleaning": "Սկսեց մաքրումը",
      "finishCleaning": "Ավարտեց մաքրումը",
      "startWork": "Սկսեց աշխատանքը",
      "closeRepair": "Փակեց պատվերը",
      "atPickup": "Վարորդը տեղում է",
      "passengerIn": "Ուղևորը մեքենայում է",
      "finishRide": "Ուղևորությունն ավարտված է",
      "scheduleLesson": "Դասը նշանակված է",
      "openLesson": "Դասը բացված է",
      "startLesson": "Դասը սկսված է",
      "finishLesson": "Դասն ավարտված է",
      "openMeeting": "Հանդիպումը բացված է",
      "startMeeting": "Հանդիպումը սկսված է",
      "finishMeeting": "Հանդիպումն ավարտված է",
      "editedByStaff": "Թիմը փոխել է կազմը",
      "checklistByStaff": "Թիմը նշել է կետը",
      "checklistUncheckedByStaff": "Թիմը հանել է նշումը"
    },
    "weekdays": {
      "0": "Երկ",
      "1": "Երք",
      "2": "Չրք",
      "3": "Հնգ",
      "4": "Ուրբ",
      "5": "Շբթ",
      "6": "Կիր"
    },
    "schedule": {
      "from": "Սկսած",
      "to": "Մինչև",
      "works": "Աշխատանքային օր"
    },
    "rate": {
      "PERCENT": "% պատվերից",
      "FIXED": "Ֆիքսված՝ պատվերի համար"
    },
    "providers": {
      "add": "Ավելացնել կատարող",
      "name": "Անուն",
      "phone": "Հեռախոս",
      "role": "Դեր",
      "company": "Ընկերություն",
      "freelancer": "Մասնավոր կատարող",
      "languages": "Լեզուներ",
      "districts": "Շրջաններ",
      "rate": "Դրույք",
      "rateType": "Դրույքի տեսակ",
      "ratePercent": "Պատվերի տոկոս",
      "rateFixed": "Գումար մեկ պատվերի համար, ֏",
      "companyRate": "ընկերության դրույք",
      "rating": "Վարկանիշ",
      "schedule": "Գրաֆիկ",
      "telegram": "Telegram",
      "linked": "կապված է",
      "resetInvite": "Նոր հրավերի հղում",
      "preset": "Դրույք",
      "ownRate": "Անհատական դրույք"
    },
    "companies": {
      "add": "Ավելացնել ընկերություն",
      "name": "Անվանում",
      "phone": "Կոնտակտային հեռախոս",
      "roles": "Ինչ պատվերներ է վերցնում",
      "employees": "Աշխատակիցներ",
      "dispatchers": "Դիսպետչերներ",
      "dispatcherInvite": "Հղում դիսպետչերի համար"
    },
    "services": {
      "plusDiscount": "Barev+ զեղչ",
      "active": "հասանելի",
      "inactive": "թաքցված",
      "availableToOrder": "Հասանելի է պատվերի համար",
      "prices": "Գներ և տևողություն",
      "variant": "Տարբերակ",
      "base": "Գին 1 սենյակի համար, ֏",
      "perRoom": "Յուրաքանչյուր հաջորդի համար, ֏",
      "baseMinutes": "Րոպե 1 սենյակի համար",
      "perRoomMinutes": "Րոպե հաջորդի համար",
      "price": "Գին, ֏",
      "minutes": "Տևողություն, րոպե",
      "lateFee": "Ուշ չեղարկման պահում, %",
      "step": "Ժամերի քայլ, րոպե",
      "dayStart": "Օրվա սկիզբ, ժ",
      "dayEnd": "Օրվա ավարտ, ժ",
      "leadHours": "Նվազագույն ժամեր մինչև սկիզբը",
      "horizon": "Գրանցում քանի օր առաջ",
      "perBathroom": "Յուրաքանչյուր հաջորդ սանհանգույցի համար, ֏",
      "perBathroomMinutes": "Րոպե սանհանգույցի համար",
      "extras": "Լրացուցիչ ծառայություններ",
      "extra": "Ծառայություն",
      "extraPrice": "Գին, ֏",
      "extraMinutes": "Րոպե մեկ միավորի համար",
      "eliteDiscount": "Elite զեղչ"
    },
    "agencies": {
      "add": "Ավելացնել անշարժ գույքի գործակալություն",
      "name": "Անվանում",
      "code": "Կոդ",
      "commission": "Վարձատրություն, %",
      "contact": "Կոնտակտ",
      "leads": "Լիդեր",
      "links": "Հղումներ QR-ի համար",
      "bot": "Անմիջապես բոտ",
      "landing": "Կայքի միջոցով",
      "hint": "Հաճախորդը կապված է գործակալությանը {{months}} ամիս՝ առաջին մուտքից։ Վարձատրությունը հաշվարկվում է միայն վճարված պատվերներից։"
    },
    "clients": {
      "name": "Հաճախորդ",
      "language": "Լեզու",
      "source": "Աղբյուր",
      "membership": "Անդամակցություն",
      "orders": "Պատվերներ",
      "since": "Մեզ հետ է",
      "noConsent": "համաձայնություն չկա",
      "source_organic": "Ինքնուրույն",
      "source_deeplink": "Գործակալության հղում",
      "source_manual_code": "Կոդ ձեռքով",
      "grant": "+30 օր Barev+",
      "grantConfirm": "Տրամադրե՞լ հաճախորդին Barev+-ի 30 օր։",
      "grantElite": "Elite 30 օրով",
      "grantEliteConfirm": "Տրամադրե՞լ հաճախորդին Barev Elite 30 օրով",
      "segment_MOVING": "տեղափոխվում է",
      "segment_LIVING": "ապրում է Հայաստանում"
    },
    "settings": {
      "cancel_freeHours": "Անվճար չեղարկում ոչ ուշ, քան, ժ առաջ",
      "agency_attributionMonths": "Հաճախորդը կապված է գործակալությանը, ամիս",
      "agency_defaultCommissionPct": "Գործակալության վարձատրություն ըստ նախնականի, %",
      "barevPlus_giftDays": "Լենդինգ․ «առաջին N օրը նվեր» (նվերը սահմանվում է յուրաքանչյուր գործակալությունում)",
      "barevPlus_monthlyPrice": "Barev+-ի ամսական գին, ֏",
      "offer_acceptTimeoutMinutes": "Կատարողի պատասխանի ժամանակ, րոպե",
      "chat_closeAfterHours": "Չատը փակվում է պատվերից հետո, ժ",
      "files_retentionDays": "Պահել փաստաթղթերի սկաները, օր",
      "consent_version": "Գաղտնիության քաղաքականության տարբերակ",
      "paymentMethods": "Վճարման եղանակներ",
      "code": "Կոդ",
      "name": "Անվանում",
      "admins": "Ադմինիստրատորներ",
      "role": "Դեր",
      "tempPassword": "Ժամանակավոր գաղտնաբառ (10+ նիշ)",
      "addAdmin": "Ավելացնել ադմինիստրատոր",
      "disable": "Անջատել",
      "enable": "Միացնել",
      "barevPlus_maxDiscountPct": "Barev+՝ զեղչ մինչև, %",
      "elite_monthlyPrice": "Barev Elite՝ ամսական գին, ֏",
      "elite_maxDiscountPct": "Barev Elite՝ զեղչ մինչև, %",
      "relocation_hotelWithPlus": "Գլխավոր՝ հյուրանոց Barev+-ով, ֏/գիշեր",
      "relocation_hotelBase": "Գլխավոր՝ հյուրանոց առանց բաժանորդագրության, ֏/գիշեր",
      "relocation_consultation": "Գլխավոր՝ տեղափոխության խորհրդատվություն, ֏",
      "docs_fromPrice": "/live՝ փաստաթղթեր «սկսած», ֏",
      "docs_socialCardPrice": "Սոցքարտ՝ ամբողջական, ֏",
      "residence_escortFrom": "Կացության քարտ՝ ուղեկցում «սկսած», ֏",
      "residence_stateFee": "Կացության քարտ՝ պետտուրք 1 տարի, ֏",
      "transfer_standardPrice": "Տրանսֆեր «Ստանդարտ», ֏",
      "transfer_premiumPrice": "Տրանսֆեր «Պրեմիում», ֏",
      "assign_auto": "Պատվերների ավտոմատ բաշխում",
      "assign_maxAutoOffers": "Քանի կատարող փորձել ավտոմատ",
      "sales_bonusPerVenue": "Վաճառողի բոնուս հաստատության համար, ֏",
      "sales_bonusPerAgency": "Վաճառողի բոնուս գործակալության համար, ֏",
      "sales_bonusAgencyPct": "Վաճառողի բոնուս՝ % գործակալությունների հաճախորդների եկամտից",
      "sales_bonusAgencyMonths": "…քանի ամիս գործակալության միանալուց հետո",
      "partner_fotPct": "Գործընկերներ (ծախսերը մերն են)․ մաքրողի աշխատավարձ, պատվերի %",
      "partner_taxPct": "Գործընկերներ (ծախսերը մերն են)․ հարկ, %",
      "partner_minTravelGapMinutes": "Գործընկերներ․ աշխատակցի պատվերների միջև նվազագույն ընդմիջում, րոպե",
      "partner_acceptTimeoutMinutes": "Գործընկերներ․ քանի րոպեում նշանակել աշխատակից, այլապես պատվերը կվերադառնա",
      "points_pendingHours": "Բարիկներ․ հասանելի են ծառայությունից N ժամ հետո",
      "points_maxSharePct": "Բարիկներ․ մինչև պատվերի N%-ը",
      "points_minRedeem": "Բարիկներ․ նվազագույնը մեկ դուրսգրման համար",
      "points_burnDays": "Բարիկներ․ այրվում են N օր անգործությունից հետո",
      "points_warnDays1": "Բարիկներ․ առաջին զգուշացումը N օր առաջ",
      "points_warnDays2": "Բարիկներ․ երկրորդ զգուշացումը N օր առաջ",
      "points_requestTtlHours": "Բարիկներ․ հաճախորդի հայտը սպասում է N ժամ",
      "points_streakGapDays": "Բարիկներ․ մաքրումների շարք՝ մինչև N օր ընդմիջում",
      "points_diffHighlightPct": "Բարիկներ․ ընդգծել ձեռքով գումարը, եթե տարբերվում է N%-ից ավելի",
      "points_supportCanManage": "Աջակցությունը նույնպես կարող է հաշվեգրել և դուրս գրել (սահմանաչափերով)",
      "points_opMaxPerOperation": "Աջակցության սահմանաչափը մեկ գործողության համար",
      "points_opMaxPerDay": "Աջակցության օրական սահմանաչափը",
      "barevPlus_monthlyPriceEur": "Barev+․ ամսական գինը առցանց վճարման համար, €",
      "elite_monthlyPriceEur": "Barev Elite․ ամսական գինը առցանց վճարման համար, €",
      "fx_eurAmd": "Փոխարժեք․ ֏ 1 €-ի դիմաց (պատվերների վերահաշվարկ եվրոյի)",
      "fx_eurRub": "Փոխարժեք․ ₽ 1 €-ի դիմաց («≈ ₽» հուշում)"
    },
    "presets": {
      "add": "Ավելացնել նախադրվածք",
      "hint": "Նախադրվածքը սահմանում է մաքրողի վարձատրությունը գնի յուրաքանչյուր տողի համար՝ ֆիքսված գումար դրամով կամ տոկոս։ Տոկոսը հաշվարկվում է Barev+ զեղչից առաջ գնից։ Նախադրվածքը նշանակվում է կատարողի քարտում։",
      "providers_one": "{{count}} կատարող",
      "providers_few": "{{count}} կատարող",
      "providers_many": "{{count}} կատարող",
      "providers_other": "{{count}} կատարող",
      "room": "Յուրաքանչյուր լրացուցիչ սենյակ",
      "bathroom": "Յուրաքանչյուր լրացուցիչ սանհանգույց",
      "name": "Նախադրվածքի անվանում",
      "applyAll": "Մեկ տոկոս բոլորի համար",
      "line": "Գնի տող",
      "type": "Տեսակ",
      "value": "Արժեք",
      "percent": "% տողից",
      "fixed": "Ֆիքսված {{unit}}",
      "perOrder": "մեկ պատվերի համար",
      "perRoom": "մեկ սենյակի համար",
      "perBathroom": "մեկ սանհանգույցի համար"
    },
    "webRequests": {
      "all": "Բոլորը",
      "status_NEW": "Բոտը չի բացել",
      "status_LINKED": "Պետք է զանգել",
      "status_ORDERED": "Պատվերը ստեղծված է",
      "status_CANCELLED": "Չեղարկված",
      "number": "№",
      "when": "Ցանկալի ժամ",
      "what": "Մաքրում",
      "contact": "Կոնտակտ",
      "address": "Հասցե",
      "price": "Գին",
      "status": "Կարգավիճակ",
      "note": "Օպերատորի նշում",
      "notePlaceholder": "Զանգել ենք, հետ զանգել…",
      "saveNote": "Պահպանել",
      "cancel": "Չեղարկել",
      "cancelConfirm": "Չեղարկե՞լ հայտ №{{number}}-ը",
      "reopen": "Վերադարձնել աշխատանքի",
      "order": "Պատվեր №{{number}}",
      "created": "Ստեղծված՝ {{date}}",
      "empty": "Հայտեր դեռ չկան։ Դրանք կհայտնվեն այստեղ, հենց որ ինչ-որ մեկը լրացնի ձևը barevclub.com/clean-ում։"
    },
    "leads": {
      "title": "Տեղափոխության հայտեր",
      "all": "Բոլորը",
      "empty": "Հարցաշարից հայտեր դեռ չկան։",
      "number": "№",
      "contact": "Կոնտակտ",
      "plan": "Երբ",
      "package": "Փաթեթ",
      "status": "Կարգավիճակ",
      "note": "Նշում",
      "created": "ստեղծվել է {{date}}",
      "unfinished": "չի ավարտել հարցաշարը",
      "moved": "արդեն ապրում է Հայաստանում",
      "status_NEW": "Նոր",
      "status_IN_WORK": "Ընթացքում",
      "status_DONE": "Պատրաստ է",
      "status_CANCELLED": "Չեղարկված",
      "budget": "{{from}}–{{to}} ֏/գիշեր",
      "inApp": "հավելվածում",
      "stepNote": "Մեկնաբանություն հաճախորդի համար",
      "stepsInApp": "Տեղափոխության պլան՝ հաճախորդը տեսնում է քայլերը հավելվածում և հաղորդագրություն ստանում կարգավիճակի փոփոխության դեպքում",
      "stepsNoApp": "Տեղափոխության պլան՝ հաճախորդը դեռ չի բացել հավելվածը",
      "addStep": "Ավելացնել քայլ",
      "addDoc": "Ավելացնել փաստաթուղթ",
      "custom": "Իմ կետը…",
      "customPlaceholder": "Անվանում այս հաճախորդի համար",
      "docsTitle": "Հաճախորդի փաստաթղթերը՝ պատրաստ է {{done}}-ը {{total}}-ից",
      "remove": "Հեռացնել հաճախորդից",
      "removeStepConfirm": "Հեռացնե՞լ «{{name}}» քայլը հաճախորդի պլանից"
    },
    "concierge": {
      "empty": "Հաղորդագրություններ դեռ չկան։ Հաճախորդները գրում են բոտին, նամակագրությունը կհայտնվի այստեղ։",
      "placeholder": "Պատասխանը կգնա հաճախորդի և բոտի չատ։ ⌘+Enter՝ ուղարկել",
      "replyLang": "հաճախորդի լեզուն՝ {{lang}}",
      "send": "Ուղարկել",
      "you": "Դուք",
      "client": "հաճախորդ",
      "provider": "կատարող",
      "startHint": "Հաղորդագրություններ դեռ չկան՝ գրեք առաջինը, այն կգնա բոտի չատ։",
      "write": "Գրել",
      "tab_all": "Բոլորը",
      "tab_clients": "Հաճախորդներ",
      "tab_providers": "Կատարողներ"
    },
    "partners": {
      "name": "Անվանում",
      "category": "Կատեգորիա",
      "offer": "Ինչ է տալիս քարտը",
      "address": "Հասցե",
      "summary": "առաջարկներ՝ {{offers}} · թիմ՝ {{members}} · ստուգումներ՝ {{visits}}",
      "manage": "Առաջարկներ և թիմ",
      "offers": "Առաջարկներ ըստ մակարդակի",
      "offerTitle": "Առաջարկ",
      "minLevel": "Ում",
      "allMembers": "Ակումբի բոլոր անդամները",
      "limit": "Որքան հաճախ",
      "limitCount": "Քանի անգամ",
      "limitKind_NONE": "Առանց սահմանափակման",
      "limitKind_ONCE": "Միայն առաջին այցը",
      "limitKind_WEEK": "N անգամ շաբաթը",
      "limitKind_MONTH": "N անգամ ամիսը",
      "limit_NONE": "առանց սահմանափակման",
      "limit_ONCE": "միայն առաջին այցը",
      "limit_WEEK": "{{count}}× շաբաթը",
      "limit_MONTH": "{{count}}× ամիսը",
      "noOffers": "Առաջարկներ չկան՝ հաճախորդները կտեսնեն միայն նկարագրությունը։",
      "team": "Սեփականատեր և աշխատակիցներ",
      "ownerLink": "Հղում սեփականատիրոջ համար",
      "ownerLinkHint": "Ուղարկեք սեփականատիրոջը կամ թույլ տվեք սկանավորել՝ կբացվի աշխատանքային բոտը, Start-ից հետո նա կդառնա սեփականատեր և կկարողանա հրավիրել աշխատակիցների։ Մեկանգամյա է։",
      "noTeam": "Դեռ ոչ ոք միացված չէ։",
      "removeConfirm": "Անջատե՞լ այս մարդուն գործընկերից"
    },
    "requests": {
      "activate": "Միացնել 30 օրով",
      "activateConfirm": "Միացնե՞լ {{plan}} 30 օրով",
      "client": "Հաճախորդ",
      "comment": "Մեկնաբանություն",
      "empty": "Հայտեր չկան։",
      "markDone": "Կապվեցինք",
      "subscription": "{{plan}} բաժանորդագրություն",
      "what": "Ինչ է պետք",
      "status_NEW": "Նոր",
      "status_DONE": "Պատրաստ է",
      "status_CANCELLED": "Չեղարկված"
    },
    "telegram": {
      "title": "Telegram՝ @{{bot}}",
      "linked": "միացված է",
      "notLinked": "միացված չէ",
      "what": "Աշխատանքային բոտը ձեզ կուղարկի՝",
      "e1": "հաճախորդների և կատարողների հաղորդագրությունները՝ կարող եք պատասխանել Telegram-ում «Պատասխանել» կոճակով",
      "e2": "տեղափոխության հայտերը՝ կայքից և հավելվածից",
      "e3": "հայտեր հավելվածից՝ բաժանորդագրություն և «զանգահարեք»",
      "e4": "նոր պատվերներ և մաքրման հայտեր կայքից",
      "how": "Սեղմեք «Միացնել»՝ կբացվի աշխատանքային բոտը, սեղմեք «Start»։ Յուրաքանչյուր օպերատոր միանում է իր մուտքով։",
      "connect": "Միացնել Telegram",
      "relink": "Միացնել այլ Telegram",
      "unlink": "Անջատել",
      "notify": "Ուղարկել ծանուցումներ"
    },
    "templates": {
      "STEP": "Տեղափոխության քայլեր",
      "STEP_hint": "Դրանցից է կազմվում հաճախորդի պլանը՝ «ամբողջական»-ը նշվածներն է, կոնստրուկտորը՝ հարցաշարում ընտրվածները",
      "DOC": "Փաստաթղթեր",
      "DOC_hint": "Չեկ-լիստ, որ ստանում է յուրաքանչյուր նոր հաճախորդ",
      "sub": "Փոփոխությունները գործում են նոր հաճախորդների համար։ Կոնկրետ հաճախորդի քայլերն ու փաստաթղթերը փոխվում են «Տեղափոխություն» բաժնում։",
      "name": "Անվանում",
      "hintField": "Հուշում",
      "active": "Ցույց տալ նոր հաճախորդներին",
      "inTurnkey": "Մտնում է «ամբողջական»-ի մեջ",
      "turnkey": "ամբողջական",
      "hidden": "թաքցված",
      "missing": "թարգմանություն չկա՝ {{langs}}"
    }
  },
  "landing": {
    "meta": {
      "title": "Barev Club — Երևանը՝ ինչպես տանը։ Առաջին օրվանից",
      "description": "Մաքրում, փաստաթղթեր, ուսում և գործընկերների զեղչեր Երևան տեղափոխվածների համար։ Ամեն ինչ Telegram-ում, 5 լեզվով։"
    },
    "nav": {
      "label": "Բաժիններ",
      "services": "Ծառայություններ",
      "how": "Ինչպես է աշխատում",
      "plans": "Անդամակցություն",
      "faq": "Հարցեր"
    },
    "openTelegram": "Բացել Telegram-ում",
    "hero": {
      "tag": "Երևան տեղափոխվածների համար",
      "title": "Երևանը՝ ինչպես տանը։ Առաջին օրվանից։",
      "sub": "Կենցաղ, փաստաթղթեր, ուսում և գործընկերների զեղչեր՝ մեկ ակումբում Telegram-ում։",
      "cta": "Միանալ անվճար",
      "services": "Դիտել ծառայությունները",
      "cleanTitle": "Բնակարանի մաքրում՝ {{price}}-ից",
      "cleanText": "Հաշվիր գինը և ընտրիր ժամը մեկ րոպեում, առանց զանգերի։",
      "cleanCta": "Հաշվել մաքրումը"
    },
    "preview": {
      "title": "Իմ հայտերը",
      "inApp": "հավելվածում",
      "cleaning": "Մաքրում · գլխավոր",
      "cleaningMeta": "Շբթ 16:00",
      "inWork": "Ընթացքում",
      "lesson": "Հայերեն A1 · դաս 3",
      "lessonMeta": "Այսօր 15:00 · առցանց",
      "today": "Այսօր",
      "cleaningRegular": "Մաքրում · ընթացիկ",
      "cleaningRegularMeta": "Այսօր 12:30"
    },
    "languages": "լեզու",
    "noInstall": "Առանց տեղադրման",
    "noInstallSub": "Ամեն ինչ Telegram-ի ներսում",
    "dir": {
      "HOME": "Ստուգված կատարողներ, պատվերի կարգավիճակը հավելվածում։",
      "HOME_cta": "Պատվիրել",
      "DOCS": "Նոտարական թարգմանություն և ուղեկցում մինչև պատրաստի փաստաթուղթ։",
      "DOCS_cta": "Ձևակերպել",
      "LEARNING": "Առցանց և անձամբ, հարմար ժամին։",
      "LEARNING_cta": "Գրանցվել",
      "soonCta": "Իմանալ մեկնարկի մասին"
    },
    "perks": {
      "upTo": "մինչև −{{pct}}%",
      "cafes": "Սրճարաններ",
      "restaurants": "Ռեստորաններ",
      "gifts": "Գործընկերների նվերներ",
      "text": "Վճարելիս ցույց տվեք ակումբային քարտը Telegram-ում։",
      "cta": "Դիտել գործընկերներին"
    },
    "how": {
      "titleBold": "Ինչպես է",
      "titleItalic": "աշխատում",
      "step1": "Սկանավորեք QR-ը",
      "step1_sub": "Վարձակալության պայմանագրից կամ կայքից",
      "step2": "Ընտրեք լեզուն",
      "step2_sub": "Հինգ լեզու ընտրության համար",
      "step3": "Պատվիրեք ծառայություն",
      "step3_sub": "Ժամ, հասցե, վճարում",
      "step4": "Հետևեք կարգավիճակին",
      "step4_sub": "Չատ կատարողի հետ ներսում"
    },
    "agency": {
      "title": "Բնակարանը վարձե՞լ եք գործընկեր անշարժ գույքի գործակալության միջոցով",
      "text": "Barev+-ի մեկ ամսվա կոդն արդեն պայմանագրում է։",
      "gift": "Նվեր։",
      "giftSub": "Barev+-ի 1 ամիս"
    },
    "plans": {
      "tryPlus": "Փորձել Barev+"
    },
    "faq": {
      "install": {
        "q": "Պե՞տք է ինչ-որ բան տեղադրել",
        "a": "Ոչ։ Ակումբն աշխատում է Telegram-ի ներսում՝ բացում եք բոտը և օգտվում։"
      },
      "languages": {
        "q": "Ի՞նչ լեզուներով կարելի է շփվել",
        "a": "Ռուսերեն, անգլերեն, չինարեն, հայերեն և իսպաներեն։"
      },
      "plus": {
        "q": "Ինչո՞վ է Barev+-ը տարբերվում անվճարից",
        "a": "Մինչև {{pct}}% զեղչեր փաստաթղթերի, կենցաղի, ուսման և կարիերայի խորհրդատվության համար։"
      },
      "gift": {
        "q": "Ինչպե՞ս ստանալ անշարժ գույքի գործակալության նվերը",
        "a": "Կոդը նշված է վարձակալության պայմանագրում։ Մուտքագրեք այն բոտում՝ և Barev+-ի {{days}} օրը ձերն է։"
      }
    },
    "footer": {
      "brand": "Barev Club · Երևան",
      "partner": "Դառնալ գործընկեր",
      "privacy": "Գաղտնիության քաղաքականություն",
      "legal": "Ա/Ձ Զաբուդկո Յուրի Կոնստանտինի · ՀՎՀՀ {{tin}}",
      "services": "Ծառայություններ",
      "pricing": "Գներ",
      "terms": "Օգտագործման պայմաններ",
      "refund": "Չեղարկում և վերադարձ",
      "rules": "Ծառայության կանոններ"
    },
    "clean": {
      "meta": {
        "title": "Բնակարանի մաքրում Երևանում — Barev Club",
        "description": "Ընթացիկ, հիմնական և վերանորոգումից հետո մաքրում։ Գինը՝ անմիջապես, ժամը ընտրում ես դու, պատվերի կարգավիճակը՝ Telegram-ում։"
      },
      "home": "Գլխավոր",
      "title": "Բնակարանի մաքրում Երևանում",
      "sub": "Հաշվիր գինը և ընտրիր ժամը։ Հայտը կհաստատենք Telegram-ում և կուղարկենք մաքրողին։",
      "duration": "Մոտ {{hours}} ժ աշխատանք",
      "extrasTitle": "Ավելացնել մաքրմանը",
      "extrasHint": "Այն ամենը, ինչ պետք է անել ստանդարտ մաքրումից բացի։",
      "whenTitle": "Երբ գալ",
      "whenHint": "Սա ցանկալի ժամն է, ճշգրիտ ժամը կհաստատենք Telegram-ում։",
      "noTimes": "Այս օրվա համար ժամ այլևս չկա, նայիր հաջորդ օրը։",
      "addressTitle": "Հասցե",
      "district": "Վարչական շրջան",
      "districtPlaceholder": "Ընտրիր շրջանը",
      "street": "Փողոց, շենք, բնակարան",
      "streetPlaceholder": "Օրինակ՝ Պուշկինի 10, բն. 5",
      "note": "Մեկնաբանություն մաքրողի համար",
      "notePlaceholder": "Դոմոֆոնի կոդը, ընտանի կենդանիներ, որտեղ են բանալիները",
      "contactTitle": "Կոնտակտներ",
      "phone": "Հեռախոս",
      "phoneHint": "Կզանգենք միայն, եթե Telegram-ով չհաջողվի կապվել։",
      "name": "Ինչպես դիմենք քեզ",
      "consent": "Համաձայն եմ անձնական տվյալների մշակմանը",
      "privacy": "Գաղտնիության քաղաքականություն",
      "summaryTitle": "Քո մաքրումը",
      "total": "Ընդամենը",
      "plusHint": "Barev+-ով՝ {{pct}}% զեղչ մաքրման համար",
      "submit": "Ուղարկել հայտը",
      "sending": "Ուղարկում ենք…",
      "after": "Ուղարկելուց հետո կբացվի Telegram-ը․ այնտեղ կհաստատենք ժամը և ցույց կտանք կարգավիճակը։",
      "err": {
        "time": "Ընտրիր ժամը։",
        "district": "Ընտրիր շրջանը։",
        "street": "Նշիր փողոցը և շենքը։",
        "phone": "Նշիր հեռախոսը երկրի կոդով, օրինակ՝ +374 91 123456։",
        "consent": "Առանց համաձայնության չենք կարող ընդունել հայտը։",
        "network": "Չհաջողվեց ուղարկել։ Ստուգիր ինտերնետը և նորից փորձիր։"
      },
      "doneTitle": "Հայտ №{{number}}-ն ընդունված է",
      "doneText": "Հիմա կբացվի Telegram-ը․ բոտը կհաստատի հայտը և ցույց կտա կարգավիճակը։ Եթե ոչինչ չկատարվեց, սեղմիր կոճակը։",
      "doneCta": "Բացել Telegram-ը",
      "doneAgain": "Ձևակերպել ևս մեկը",
      "includedTitle": "Ինչ է ներառված",
      "zone": {
        "kitchen": "Խոհանոց",
        "bathroom": "Սանհանգույց",
        "rooms": "Սենյակներ"
      },
      "inc": {
        "kitchen": "Լվանում ենք լվացարանը և ծորակը\nՄաքրում ենք սալօջախը, սեղանի մակերեսը և պատը\nՄաքրում ենք պահարանների ճակատները և տեխնիկան դրսից\nԼվանում ենք հատակը և դուրս հանում աղբը",
        "bathroom": "Լվանում ենք լոգարանը կամ ցնցուղը, լվացարանը և զուգարանակոնքը\nՄաքրում ենք հայելիները և ծորակները\nՄաքրում ենք դարակները և դռները\nԼվանում ենք հատակը",
        "rooms": "Մաքրում ենք փոշին հասանելի մակերեսներից\nՓոշեկուլով մաքրում և լվանում ենք հատակը\nՀարդարում ենք մահճակալը, դասավորում իրերը\nՄաքրում ենք հայելիները և անջատիչները"
      },
      "general": "Հիմնական մաքրում՝ այս ամենը, գումարած դժվարամատչելի տեղերը՝ կահույքի հետևում, շրիշակներ, դռներ, մարտկոցներ և պահարանների ներսը։",
      "renovation": "Վերանորոգումից հետո՝ նաև շինարարական փոշին և ներկի, սոսնձի ու ցեմենտի հետքերը բոլոր մակերեսներից։",
      "howTitle": "Ինչպես է աշխատում",
      "how1": "Թողնում ես հայտը այստեղ",
      "how1Sub": "Գինը երևում է անմիջապես, առանց զանգերի",
      "how2": "Հաստատում ենք Telegram-ում",
      "how2Sub": "Բոտը ցույց կտա պատվերը և դրա կարգավիճակը",
      "how3": "Գալիս է մաքրողը",
      "how3Sub": "Աշխատում է ըստ ստուգաթերթի և ուղարկում լուսանկարներով հաշվետվություն",
      "whenHintOptional": "Ոչ պարտադիր․ եթե չընտրեք, բոտը կհարցնի Telegram-ում։",
      "addressHintOptional": "Ոչ պարտադիր․ հասցեն կարող եք գրել բոտին ուղարկելուց հետո։",
      "nameTitle": "Ինչպես դիմել ձեզ",
      "consentByClick": "Սեղմելով կոճակը՝ համաձայնում եք անձնական տվյալների մշակմանը։"
    },
    "v1": {
      "title": "Երևանում ապրելու համար ամեն ինչ՝ մեկ չատում",
      "sub": "Barev Club-ը բոտ է Telegram-ում։ Գրում ես, թե ինչ է պետք, անմիջապես տեսնում ես գինը և ընտրում ժամը։ Մնացածը մենք ենք անում։",
      "botName": "Barev Club",
      "botStatus": "բոտ, պատասխանում է անմիջապես",
      "u1": "Բարև։ Շաբաթ օրը մաքրում է պետք, 2 սենյակ",
      "b1": "Բարև։ Ընթացիկ մաքրում, 2 սենյակ և սանհանգույց՝ {{price}}։ Շաբաթ, 11:00-ը հարմա՞ր է։",
      "u2": "Այո, հիանալի է",
      "b2": "Պատրաստ է։ Մաքրողը կգա 11:00-ին, կարգավիճակը և լուսանկարներով հաշվետվությունը կուղարկեմ այստեղ։",
      "canTitle": "Ինչ կարելի է պատվիրել",
      "canText": "Մաքրումն արդեն աշխատում է։ Մնացածը գործարկում ենք հերթով, բոտը կգրի, երբ բացվի։",
      "whyTitle": "Ինչու Telegram-ում",
      "why1": "Ոչինչ պետք չէ տեղադրել",
      "why1Sub": "Բոտը և հավելվածը բացվում են հենց Telegram-ում։",
      "why2": "Հինգ լեզու",
      "why2Sub": "Ռուսերեն, անգլերեն, չինարեն, հայերեն և իսպաներեն։",
      "why3": "Ամեն ինչ մեկ նամակագրությունում",
      "why3Sub": "Կարգավիճակը, չատը կատարողի հետ և լուսանկարները՝ այնտեղ, որտեղ արդեն շփվում ես։",
      "ctaTitle": "Սկսիր «Barev»-ից",
      "ctaText": "Այդպես է հայերեն «բարև»-ը։ Գրիր բոտին, նա կպատասխանի քո լեզվով։",
      "cta": "Գրել բոտին"
    },
    "v2": {
      "hello": "Привет\nHello\n你好\nԲարև\nHola",
      "title": "Տեղափոխություն Երևան՝ քայլ առ քայլ",
      "sub": "Օդանավակայանից մինչև քո բնակարանը և փաստաթղթերը։ Ակումբը կողքիդ է ամեն քայլում, իսկ բոլոր հարցերը լուծվում են մեկ չատում։",
      "calc": "Հաշվել",
      "ctaTitle": "Ակումբն անվճար է",
      "ctaText": "Միացիր Telegram-ում, բոլոր քայլերը ձեռքի տակ կլինեն՝ քո լեզվով։",
      "cta": "Միանալ ակումբին",
      "whenArrive": "Ժամանում",
      "whenWeek": "Առաջին շաբաթ",
      "whenSettled": "Տեղավորվելուց հետո",
      "whenLater": "Հետո",
      "whenDaily": "Ամեն օր",
      "whenAnytime": "Ցանկացած պահի",
      "airportTitle": "Կդիմավորենք օդանավակայանում և կտեղավորենք հյուրանոցում",
      "airportText": "Վարորդը ցուցանակով Զվարթնոցում և տրանսֆեր մինչև հյուրանոց՝ առաջին օրերն առանց հոգսերի։",
      "flatTitle": "Կգտնենք բնակարան",
      "flatText": "Կընտրենք բնակարան գործընկեր անշարժ գույքի գործակալությունների միջոցով, իսկ տեղափոխվելուց առաջ կմաքրենք։",
      "docsTitle": "Կանենք գրանցումը և սոցքարտը",
      "docsText": "Կպատրաստենք փաստաթղթերը, կգրանցենք և կուղեկցենք մինչև պատրաստի քարտը։",
      "permitTitle": "Կօգնենք ԿՔ-ի փաստաթղթերով",
      "permitText": "Կհավաքենք փաթեթը, կթարգմանենք և կվավերացնենք, կհուշենք ժամկետները և ներկայացման կարգը։",
      "perksTitle": "Օգտվիր ակումբի զեղչերից և արտոնություններից",
      "perksText": "Սրճարաններ, ռեստորաններ և գործընկերների նվերներ ակումբային քարտով, իսկ Barev+-ով՝ նաև զեղչեր ծառայությունների համար։",
      "chatTitle": "Ցանկացած հարց՝ չատում",
      "chatText": "Ծորակը փչացել է, թե՞ ժամկետանց ես մնացել Հայաստանում՝ գրիր «օգնեք»։ Կլուծենք և կհուշենք՝ ինչ անել։",
      "chatChip": "Telegram-ում",
      "chatCta": "Գրել չատում"
    },
    "v3": {
      "tag": "Գործընկեր անշարժ գույքի գործակալությունների վարձակալների համար",
      "title": "Բարի գալուստ տուն",
      "sub": "Անշարժ գույքի գործակալությունը, որի միջոցով վարձել ես բնակարանը, նվիրում է Barev+ բաժանորդագրություն՝ զեղչեր մաքրման, փաստաթղթերի և դասերի համար։",
      "giftTitle": "Barev+-ի 1 ամիս",
      "giftCode": "{{code}} կոդը կկիրառվի ինքնաբերաբար",
      "giftNoCode": "Կոդը վարձակալության պայմանագրում է",
      "stepsTitle": "Ինչպես ստանալ",
      "step1": "Սեղմիր «Ստանալ նվերը»",
      "step1Sub": "Կբացվի Barev Club բոտը Telegram-ում։",
      "step2": "Ընտրիր լեզուն և հաստատիր համաձայնությունը",
      "step2Sub": "Կտևի տասը վայրկյան։",
      "step3": "Նվերը կմիանա ինքնաբերաբար",
      "step3Sub": "Զեղչերը անմիջապես կկիրառվեն պատվերներին։",
      "benefitsTitle": "Ինչ է տալիս Barev+-ի մեկ ամիսը",
      "cleaningDeal": "Մաքրում՝ {{price}}-ից {{full}}-ի փոխարեն",
      "cleaningDealSub": "Ընթացիկ մաքրում, զեղչն արդեն ներառված է։",
      "cta": "Ստանալ նվերը",
      "noCode": "Կոդ չկա՞։ Ուղարկիր այն բոտին /code հրամանով կամ միացիր առանց դրա՝ ակումբն անվճար է։"
    },
    "v4": {
      "title": "Ժամանե՞լ ես Երևան։ Մնացածը մենք կանենք",
      "sub": "Մաքրում, փաստաթղթեր և հայերենի դասեր՝ պատվիրում ես Telegram-ում քո լեզվով, կարծես վաղուց ես այստեղ ապրում։",
      "board": "Ժամանում",
      "city": "Երևան",
      "colFlight": "Չվերթ",
      "colService": "Ծառայություն",
      "colPrice": "Գին",
      "colStatus": "Կարգավիճակ",
      "live": "Աշխատում է",
      "soon": "Շուտով",
      "passTitle": "Նստեցման տոմս",
      "passenger": "Ուղևոր",
      "passengerValue": "Դու",
      "from": "Որտեղից",
      "fromValue": "Ցանկացած տեղից",
      "to": "Ուր",
      "toValue": "Երևան, ինչպես տանը",
      "gate": "Ելք",
      "gateValue": "Telegram",
      "cta": "Անցնել նստեցման",
      "clean": "Անմիջապես պատվիրել մաքրում"
    },
    "v5": {
      "title": "Որքան կխնայես Barev+-ով",
      "sub": "Ազնիվ հաշվարկ՝ բաժանորդագրության գինն արդեն հանված է խնայողությունից։",
      "perMonth": "Մաքրում ամսական",
      "without": "Առանց Barev+",
      "with": "Barev+-ով",
      "withNote": "ներառյալ {{price}} բաժանորդագրությունը",
      "save": "Խնայողություն ամսական",
      "noSave": "Առայժմ ավելի շահավետ է առանց բաժանորդագրության",
      "breakeven": "Barev+-ը փոխհատուցվում է նման չափի ամսական {{count}} մաքրումից։",
      "breakevenFirst": "Barev+-ը փոխհատուցվում է նման չափի առաջին իսկ մաքրումից։",
      "perYear": "Տարեկան՝ {{amount}}",
      "other": "Բաժանորդագրությունը գործում է նաև այլ ուղղությունների համար",
      "cta": "Փորձել Barev+",
      "gift": "Վարձե՞լ ես գործընկեր անշարժ գույքի գործակալության միջոցով։ Բաժանորդագրությունը նվեր է։"
    },
    "v6": {
      "tag": "Անշարժ գույքի գործակալությունների համար",
      "title": "Պայմանագիր այն մասին, թե ինչպես են ձեր վարձակալները տեղավորվում Երևանում",
      "sub": "Դուք հաճախորդներին նվիրում եք Barev+-ի մեկ ամիս, մենք օգնում ենք նրանց կենցաղում, իսկ դուք ստանում եք տոկոս նրանց պատվերներից։",
      "docDate": "Երևան",
      "s1": "Ինչ է ստանում անշարժ գույքի գործակալությունը",
      "s1i1": "Հաճախորդի յուրաքանչյուր պատվերի {{pct}}%-ը բոտ առաջին մուտքից հետո {{months}} ամսվա ընթացքում։",
      "s1i2": "Ձեր կոդը և QR-ը՝ կարելի է ավելացնել վարձակալության պայմանագրում կամ փոխանցել բանալիների հետ։",
      "s1i3": "Հաշվետվություն հաճախորդների և պատվերների մասին՝ քանիսն եկան, քանիսը պատվիրեցին և որքան վաստակեցիք։",
      "s2": "Ինչ է ստանում վարձակալը",
      "s2i1": "Barev+ {{days}} օրով նվեր՝ զեղչեր մաքրման, փաստաթղթերի և դասերի համար։",
      "s2i2": "Ծառայություն հինգ լեզվով Telegram-ում՝ առանց հավելվածների և զանգերի։",
      "s2i3": "Ստուգված կատարողներ և յուրաքանչյուր պատվերի կարգավիճակ։",
      "s3": "Ինչպես միանալ",
      "s3i1": "Գրեք մեզ բոտում, կպատասխանենք մեկ օրվա ընթացքում։",
      "s3i2": "Ստացեք գործակալության կոդը և QR-ը։",
      "s3i3": "Ավելացրեք QR-ը վարձակալության պայմանագրում։ Մնացածը մեզ վրա է։",
      "exampleTitle": "Օրինակ",
      "exampleText": "{{clients}} հաճախորդ × ամսական {{orders}} մաքրում × {{price}}",
      "exampleResult": "{{amount}} գործակալությանը ամսական",
      "exampleNote": "Հաշվարկը՝ երկսենյականոց բնակարանի ընթացիկ մաքրման համար։",
      "signAgency": "Անշարժ գույքի գործակալություն",
      "signUs": "Barev Club",
      "cta": "Դառնալ գործընկեր"
    },
    "home": {
      "metaTitle": "Տեղափոխություն Հայաստան՝ բնակարան, սոցքարտ, կացության քարտ — Barev Club",
      "metaDescription": "Կդիմավորենք Զվարթնոց օդանավակայանում, կգտնենք բնակարան Երևանում, սոցքարտը՝ 1 օրում, գրանցում և կացության քարտի փաստաթղթեր։ Մեկ Telegram չատ՝ 5 լեզվով։",
      "switchLabel": "Ում համար է էջը",
      "switchMove": "Տեղափոխվում եմ",
      "switchLive": "Արդեն ապրում եմ Հայաստանում",
      "title": "Տեղափոխություն Հայաստան՝ քայլ առ քայլ",
      "sub": "Կդիմավորենք օդանավակայանում, կգտնենք բնակարան և կձևակերպենք փաստաթղթերը։ Բոլոր հարցերը՝ մեկ չատում, ձեր լեզվով։",
      "cta": "Ընտրել տեղափոխության պլան",
      "ctaChat": "Գրել Telegram-ով",
      "whenArrive": "Ժամանում",
      "whenFirst": "Առաջին օրերը",
      "whenSettled": "Տեղավորվելուց հետո",
      "whenLater": "Հետագայում",
      "whenDaily": "Ամեն օր",
      "whenAnytime": "Ցանկացած պահի",
      "airportTitle": "Կդիմավորենք օդանավակայանում և կտեղավորենք հյուրանոցում",
      "airportText": "Վարորդը ցուցանակով Զվարթնոցում, տրանսֆեր և հյուրանոցային համար՝ առաջին օրերն առանց հոգսերի։",
      "flatTitle": "Կգտնենք բնակարան",
      "flatText": "Տարբերակներ 1 օրում, դիտումները՝ հաջորդ օրը։",
      "docsTitle": "Կանենք գրանցում և սոցքարտ",
      "docsText": "Կպատրաստենք փաստաթղթերը և կուղեկցենք մինչև պատրաստի քարտը։ Սոցքարտը՝ հաջորդ օրը։",
      "permitTitle": "Կօգնենք կացության քարտի փաստաթղթերով",
      "permitText": "Աշխատանքի միջոցով՝ կհավաքենք փաթեթը, կթարգմանենք և կվավերացնենք, կասենք ներկայացման ժամկետները։",
      "perksTitle": "Օգտվեք ակումբի զեղչերից և արտոնություններից",
      "perksText": "Զեղչեր ծառայությունների համար և նվերներ գործընկերներից՝ Barev+ և Barev Elite բաժանորդագրությամբ։",
      "chatTitle": "Ցանկացած հարց՝ չատում",
      "chatText": "Ծորակը փչացել է, թե Հայաստանում մնալու ժամկետն է անցել՝ գրեք «օգնեք», կպարզենք և կասենք՝ ինչ անել։",
      "chatCta": "Գրել չատում",
      "finalTitle": "Պատմեք ձեր տեղափոխության մասին",
      "finalText": "Մի քանի հարց, և մենք կկազմենք տեղափոխության պլան ու կհաշվենք գինը։",
      "more": "Մանրամասն",
      "perksSoon": "Շուտով"
    },
    "live": {
      "metaTitle": "Զեղչեր Երևանում ծառայությունների համար՝ բաժանորդագրությամբ — Barev Club",
      "metaDescription": "Ակումբի բաժանորդագրություն՝ մինչև −{{pct}}% մաքրման, վերանորոգման, տրանսֆերի, էքսկուրսիաների և փաստաթղթերի համար, լեզուներ և կարիերայի խորհրդատվություն, նվերներ գործընկերներից։",
      "title": "Ապրո՞ւմ եք Հայաստանում։ Ակումբով ավելի էժան է",
      "sub": "Ձևակերպեք բաժանորդագրություն և ստացեք զեղչեր այն ծառայությունների համար, որոնք պետք են ամեն ամիս։",
      "cta": "Ձևակերպել բաժանորդագրություն",
      "ctaPlans": "Համեմատել սակագները",
      "listTitle": "Ինչի վրա են գործում զեղչերը",
      "listNote": "Առավելագույն զեղչը՝ Barev Elite-ով։ Barev+-ով՝ մինչև −{{pct}}%։",
      "upTo": "մինչև −{{pct}}%",
      "discount": "զեղչ",
      "gifts": "նվերներ",
      "cleaning": "Մաքրում",
      "cleaningHint": "սովորական, գլխավոր, վերանորոգումից հետո",
      "repair": "Վերանորոգում",
      "repairHint": "սանտեխնիկ, էլեկտրիկ, մանր վերանորոգում",
      "transfer": "Տրանսֆեր",
      "transferHint": "օդանավակայանից և օդանավակայան",
      "tours": "Էքսկուրսիաներ",
      "toursHint": "Գառնի, Գեղարդ, Սևան և ոչ միայն",
      "docs": "Փաստաթղթեր",
      "docsHint": "սոցքարտ, կացության քարտ, գրանցում, ԱՁ և ՍՊԸ բացում",
      "lang": "Լեզուներ",
      "langHint": "անգլերեն և հայերեն",
      "career": "Կարիերա",
      "careerHint": "ռեզյումե, LinkedIn պրոֆիլ, պատրաստություն հարցազրույցին",
      "partners": "Գործընկերներ",
      "partnersHint": "ակումբի սրճարաններ, ռեստորաններ և խանութներ",
      "finalTitle": "Բաժանորդագրությունը ձևակերպվում է Telegram-ում",
      "finalText": "Բացեք ակումբի բոտը, ընտրեք սակագինը՝ զեղչերը կերևան ծառայությունների գներում։",
      "orderNow": "Պատվիրել հիմա",
      "docsFrom": "{{price}}-ից՝ բաժանորդագրությամբ"
    },
    "club": {
      "title": "Ակումբի բաժանորդագրություն",
      "sub": "Ծառայություններ պատվիրելն անվճար է։ Զեղչերը և կոնսիերժը՝ բաժանորդագրությամբ։",
      "free": "անվճար",
      "perMonth": "{{price}}/ամիս",
      "freeF1": "Պատվերներ և կարգավիճակներ Telegram բոտում",
      "freeF2": "Վճարում և չատ յուրաքանչյուր հայտի համար",
      "freeF3": "Ծառայությունների սովորական գներ",
      "plusF1": "Մինչև −{{pct}}% ծառայությունների համար",
      "plusF2": "Նվերներ գործընկերներից",
      "plusF3": "Կոնսիերժ չատում աշխատանքային օրերին՝ 10-ից 18",
      "eliteF1": "Մինչև −{{pct}}% ծառայությունների համար",
      "eliteF2": "Նվերներ գործընկերներից",
      "eliteF3": "Կոնսիերժ չատում 24/7՝ լուծում ենք ցանկացած հարց",
      "freeCta": "Բացել բոտը",
      "plusCta": "Ձևակերպել Barev+",
      "eliteCta": "Ձևակերպել Elite"
    },
    "quiz": {
      "dialog": "Տեղափոխության պլան",
      "close": "Փակել",
      "back": "Հետ",
      "next": "Առաջ",
      "progress": "Քայլ {{n}}՝ {{total}}-ից",
      "sending": "Պահպանում ենք…",
      "contactTitle": "Ինչպե՞ս դիմել ձեզ",
      "name": "Անուն",
      "contact": "Հեռախոս կամ Telegram",
      "contactHint": "+374 … կամ @username",
      "consentPre": "Սեղմելով «Առաջ»՝ համաձայնում եք ",
      "consentLink": "գաղտնիության քաղաքականությանը",
      "errName": "Գրեք, թե ինչպես դիմել ձեզ։",
      "errContact": "Անհրաժեշտ է հեռախոս (+374…) կամ Telegram-ի անուն (@username)։",
      "movedTitle": "Արդեն տեղափոխվե՞լ եք Հայաստան",
      "movedYes": "Այո, արդեն ապրում եմ այստեղ",
      "movedNo": "Ոչ, դեռ պլանավորում եմ",
      "movingToLive": "Բացում ենք էջը Հայաստանում արդեն ապրողների համար…",
      "whenTitle": "Ե՞րբ եք պլանավորում տեղափոխվել",
      "when_month": "Մոտակա ամսում",
      "when_quarter": "1–3 ամսից",
      "when_later": "Ավելի ուշ, դեռ նայում եմ",
      "when_date": "Գիտեմ ճշգրիտ ամսաթիվը",
      "date": "Ժամանման ամսաթիվ",
      "errWhen": "Ընտրեք տարբերակ կամ նշեք ամսաթիվը։",
      "packageTitle": "Ծառայությունների ո՞ր փաթեթն է պետք",
      "package_CONSULT": "Միայն խորհրդատվություն",
      "package_CONSULT_text": "Կքննարկենք ձեր դեպքը և կկազմենք տեղափոխության պլան։",
      "package_TURNKEY": "Ամբողջական",
      "package_TURNKEY_text": "Օդանավակայանում դիմավորելուց մինչև կացության քարտ կամ գրանցում։ Ճշգրիտ գինը կհաշվենք հայտով։",
      "package_TURNKEY_price": "հաշվարկով",
      "package_CUSTOM": "Ինքս կհավաքեմ",
      "package_CUSTOM_text": "Նշեք միայն անհրաժեշտ ծառայությունները։",
      "customTitle": "Հավաքեք ձեր փաթեթը",
      "airport": "Դիմավորում օդանավակայանում",
      "airport_none": "Պետք չէ",
      "airport_standard": "Ստանդարտ",
      "airport_premium": "Պրեմիում",
      "stay": "Բնակություն առաջին օրերի համար",
      "stay_none": "Պետք չէ",
      "stay_flat": "Բնակարան",
      "stay_hotel": "Հյուրանոց",
      "budget": "Բյուջե մեկ գիշերվա համար, ֏",
      "budgetFrom": "սկսած",
      "budgetTo": "մինչև",
      "flat": "Բնակարանի որոնում",
      "socialCard": "Սոցքարտ",
      "bankCard": "Բանկային քարտ",
      "registration": "Գրանցում",
      "residence": "Կացության քարտ",
      "no": "Ոչ",
      "yes": "Այո",
      "yesHint": "Կկապվենք և կճշտենք մանրամասները",
      "errEmpty": "Նշեք գոնե մեկ ծառայություն։",
      "submit": "Ուղարկել հայտը",
      "doneTitle": "Հայտ №{{number}} ընդունված է",
      "doneText": "Կկապվենք ձեզ հետ մեկ օրվա ընթացքում՝ {{contact}}։",
      "doneBot": "Բացել ակումբը Telegram-ում",
      "doneClose": "Վերադառնալ կայք",
      "errNetwork": "Սերվերի հետ կապ չկա։ Ստուգեք ինտերնետը և փորձեք կրկին։"
    },
    "seo": {
      "org": "Barev Club-ը ակումբ-ծառայություն է Երևան տեղափոխվողների և Հայաստանում արդեն ապրողների համար՝ դիմավորում օդանավակայանում, բնակարան, սոցքարտ, կացության քարտ, մաքրում և գործընկերների զեղչեր։ Ամենը Telegram-ում՝ 5 լեզվով։"
    },
    "svc": {
      "common": {
        "home": "Գլխավոր",
        "updated": "Թարմացվել է 2026 թ. հոկտեմբերի 20-ին",
        "factsTitle": "Հակիրճ",
        "pricesTitle": "Գներ",
        "faqTitle": "Հաճախ տրվող հարցեր",
        "relatedTitle": "Եվս տեղափոխության մասին",
        "cta": "Գրել Telegram-ում",
        "ctaMove": "Ամբողջական տեղափոխություն",
        "clean": "Բնակարանի մաքրում",
        "breadcrumbs": "Նավիգացիա"
      },
      "socialCard": {
        "meta": {
          "title": "Սոցքարտ Հայաստանում օտարերկրացիների համար՝ փաստաթղթեր, ժամկետ, գին — Barev Club",
          "description": "Ինչպես ստանալ սոցքարտ (ՀԾՀ) Հայաստանում 2026 թվականին՝ ինչ փաստաթղթեր են պետք, ուր գնալ և որքան սպասել։ Կանենք ամբողջությամբ {{price}}-ով, սովորաբար 1 օրում։"
        },
        "crumb": "Սոցքարտ",
        "h1": "Սոցքարտ Հայաստանում՝ ինչպես ստանալ 1 օրում",
        "lead": "Սոցքարտը հանրային ծառայությունների համարանիշն է (ՀԾՀ)՝ 10 թվանշան։ Առանց դրա Հայաստանում չեք կարող բանկային հաշիվ բացել, ԱՁ գրանցել կամ կացության քարտի դիմում ներկայացնել։ Օտարերկրացուն համարը տալիս են Միգրացիոն ծառայության ստորաբաժանումում, սովորաբար դիմելու օրը։ Barev Club-ը կանի ամեն ինչ {{price}}-ով՝ անձնագրի թարգմանություն, գրանցում և ուղեկցում։",
        "priceLabel": "Ամբողջությամբ",
        "priceValue": "{{price}}",
        "priceNote": "անձնագրի թարգմանություն, նոտար, գրանցում և ուղեկցում",
        "facts": {
          "f1": {
            "label": "Ժամկետ",
            "value": "սովորաբար 1 օր"
          },
          "f2": {
            "label": "Գին",
            "value": "{{price}}՝ ամբողջությամբ"
          },
          "f3": {
            "label": "Որտեղ են տալիս",
            "value": "ՆԳՆ Միգրացիոն ծառայության ստորաբաժանում"
          },
          "f4": {
            "label": "Ինչ է պետք ձեզնից",
            "value": "անձնագիր՝ մուտքի կնիքով"
          }
        },
        "stepsTitle": "Ինչպես է դա անցնում մեզ հետ",
        "steps": {
          "s1": {
            "when": "Օր 1",
            "title": "Գրում եք Telegram-ում",
            "text": "Ուղարկում եք անձնագրի լուսանկարը և Երևանի հասցեն։ Վարձով բնակարանի կամ հյուրանոցի հասցեն էլ է հարմար։"
          },
          "s2": {
            "when": "Օր 1",
            "title": "Նոտարական թարգմանություն",
            "text": "Թարգմանում ենք անձնագրի գլխավոր էջը հայերեն և վավերացնում նոտարի մոտ։"
          },
          "s3": {
            "when": "Օր 1",
            "title": "Գրանցում ենք ստորաբաժանում",
            "text": "Ընտրում ենք կարճ հերթով ստորաբաժանում և ձեզ հարմար ժամ։"
          },
          "s4": {
            "when": "Օր 1–2",
            "title": "Գնում ենք միասին",
            "text": "Ուղեկցողը խոսում է հայերեն և լրացնում է դիմումը։ Ձեզնից պահանջվում է միայն գալ անձնագրով։"
          },
          "s5": {
            "when": "Օր 1–2",
            "title": "Ստանում եք համարը",
            "text": "Համարով տեղեկանքը սովորաբար տալիս են անմիջապես, երբեմն՝ հաջորդ օրը։"
          }
        },
        "blocks": {
          "b1": {
            "title": "Ինչ է սոցքարտը",
            "body": "Սոցքարտը հանրային ծառայությունների համարանիշի (ՀԾՀ) խոսակցական անվանումն է։ Դա եզակի 10-նիշ համար է, որը պետությունը տալիս է Հայաստանի քաղաքացիներին և երկրում օրինական գտնվող օտարերկրացիներին։\nՕտարերկրացիներին տալիս են ոչ թե պլաստիկ քարտ, այլ համարով տեղեկանք։ Եթե արդեն ունեք կացության քարտ, համարը կարող է նշված լինել դրանում։"
          },
          "b2": {
            "title": "Ինչի համար է պետք",
            "body": "• բանկային հաշիվ և քարտ բացել Հայաստանում.\n• ԱՁ կամ ՍՊԸ գրանցել.\n• հարկեր վճարել և պաշտոնապես աշխատավարձ ստանալ.\n• կացության քարտի դիմում ներկայացնել.\n• գրանցվել բժշկի մոտ պետական պոլիկլինիկայում.\n• մեքենա գնել և հայկական վարորդական իրավունք ստանալ։"
          },
          "b3": {
            "title": "Ինչ փաստաթղթեր են պետք",
            "body": "• Անձնագիր՝ Հայաստան մուտքի կնիքով։\n• Անձնագրի գլխավոր էջի նոտարական թարգմանություն հայերեն. այն անում ենք մենք։\n• Հասցե Հայաստանում. հարմար է վարձով բնակարան կամ հյուրանոց, գրանցում պետք չէ։\n• Եթե մուտք եք գործել ՌԴ ներքին անձնագրով, պետք կլինի նաև դրա նոտարական թարգմանությունը։ Դա կարող է ավելացնել մի քանի օր։\nԵրբեմն ստորաբաժանումը խնդրում է ծննդյան վկայական կամ գրանցման փաստաթուղթ։ Եթե պետք լինի, կասենք նախապես։"
          },
          "b4": {
            "title": "Ինչ է փոխվում 2026 թ. նոյեմբերի 1-ից",
            "body": "2026 թվականի նոյեմբերի 1-ից Հայաստանում ուժի մեջ է մտնում օտարերկրացիների մասին նոր օրենքը, և փոխվում է Միգրացիոն ծառայություն գրանցվելու համակարգը։ Մենք հետևում ենք փոփոխություններին և կգրանցենք ձեզ գործող կանոններով։"
          }
        },
        "prices": {
          "p1": {
            "name": "Սոցքարտ՝ ամբողջությամբ",
            "value": "{{price}}",
            "note": "անձնագրի թարգմանություն, նոտար, գրանցում, ուղեկցում"
          },
          "p2": {
            "name": "Barev+ բաժանորդագրությամբ",
            "value": "−{{docsPct}}%",
            "note": "զեղչ բոլոր փաստաթղթային ծառայությունների համար"
          }
        },
        "faq": {
          "q1": {
            "q": "Կարելի՞ է սոցքարտ ստանալ առանց կացության քարտի",
            "a": "Այո։ Համարը տալիս են Հայաստանում օրինական գտնվող օտարերկրացիներին, օրինակ՝ մուտքի կնիքով։ Կացության քարտ դրա համար պետք չէ։"
          },
          "q2": {
            "q": "Որքա՞ն ժամանակ է տևում սոցքարտի ձևակերպումը",
            "a": "Հիմնականում տեղեկանքը տալիս են դիմելու օրը, որոշ ստորաբաժանումներում՝ հաջորդ օրը։ Անձնագրի նոտարական թարգմանությունը անում ենք նախապես, ուստի սովորաբար ամեն ինչ տևում է 1–2 օր։"
          },
          "q3": {
            "q": "Պե՞տք է արդյոք իմանալ հայերեն",
            "a": "Ոչ։ Ձեզ հետ կգնա ուղեկցող, որը խոսում է հայերեն և ռուսերեն և կլրացնի դիմումը ձեր փոխարեն։"
          },
          "q4": {
            "q": "Կարելի՞ է սոցքարտ ստանալ առանց անձամբ ներկայանալու",
            "a": "Տեղեկանքը կարող է ստանալ լիազորագրով ներկայացուցիչը, իսկ հայկական էլեկտրոնային ստորագրության դեպքում՝ առցանց։ Եթե Երևանում չեք, գրեք մեզ՝ կգտնենք տարբերակ։"
          },
          "q5": {
            "q": "Ինչո՞վ է սոցքարտը տարբերվում ՀՎՀՀ-ից",
            "a": "Սոցքարտը (ՀԾՀ) մարդու անձնական համարն է։ ՀՎՀՀ-ն հարկ վճարողի համարն է, որը ստանում են ԱՁ-ներն ու ընկերությունները։ ԱՁ բացելու համար նախ պետք է սոցքարտ։"
          }
        },
        "finalTitle": "Սոցքա՞րտ է պետք",
        "finalText": "Գրեք Telegram-ում. կգրանցենք մոտակա հարմար օրվա համար և կթարգմանենք անձնագիրը։"
      },
      "residence": {
        "meta": {
          "title": "Կացության քարտ Հայաստանում 2026՝ նոր կանոններ նոյեմբերի 1-ից, հիմքեր, գին — Barev Club",
          "description": "Ինչպես ստանալ կացության քարտ Հայաստանում նոր օրենքով՝ աշխատանք, ԱՁ, ՍՊԸ, ընտանիք։ Պետտուրք {{fee}}, դիմում առցանց։ Խորհրդատվություն {{consult}}, ուղեկցում՝ {{escort}}-ից։"
        },
        "crumb": "Կացության քարտ",
        "h1": "Կացության քարտ Հայաստանում 2026-ին՝ ինչ է փոխվել և ինչպես ստանալ",
        "lead": "2026 թվականի նոյեմբերի 1-ից Հայաստանում գործում է օտարերկրացիների մասին նոր օրենքը։ Կացության քարտի դիմումը ներկայացնում են առցանց, սկզբում տալիս են 1 տարով, իսկ պետտուրքը բարձրացել է մինչև {{fee}}։ Հիմքերն են աշխատանքը, ԱՁ-ն, ՍՊԸ-ն, ուսումը կամ ընտանիքը։ Barev Club-ը կընտրի հիմքը և կուղեկցի ձեզ մինչև քարտի ստացումը։",
        "priceLabel": "Ուղեկցում",
        "priceValue": "{{escort}}-ից",
        "priceNote": "+ պետտուրք {{fee}}։ Խորհրդատվությունը ({{consult}}) հաշվարկվում է",
        "facts": {
          "f1": {
            "label": "Նոր կանոններ",
            "value": "2026 թ. նոյեմբերի 1-ից"
          },
          "f2": {
            "label": "Պետտուրք",
            "value": "{{fee}}՝ 1 տարվա համար"
          },
          "f3": {
            "label": "Դիմում",
            "value": "առցանց + մեկ այց մատնահետքերի համար"
          },
          "f4": {
            "label": "Ուղեկցում",
            "value": "{{escort}}-ից"
          }
        },
        "stepsTitle": "Ինչպես ենք վարում կացության քարտի գործը",
        "steps": {
          "s1": {
            "when": "Շաբաթ 1",
            "title": "Խորհրդատվություն",
            "text": "Քննարկում ենք ձեր դեպքը և ընտրում հիմքը՝ աշխատանք, ԱՁ, ՍՊԸ կամ ընտանիք։ {{consult}} խորհրդատվությունը հաշվարկվում է ուղեկցման մեջ։"
          },
          "s2": {
            "when": "Շաբաթ 1–2",
            "title": "Պատրաստում ենք հիմքը",
            "text": "Օգնում ենք բացել ԱՁ կամ ՍՊԸ, մուտքագրել անհրաժեշտ գումարը կամ կնքել աշխատանքային պայմանագիր։"
          },
          "s3": {
            "when": "Շաբաթ 2–3",
            "title": "Հավաքում ենք փաստաթղթերը",
            "text": "Թարգմանում և վավերացնում ենք փաստաթղթերը, ձևակերպում ենք սոցքարտը, եթե դեռ չունեք։"
          },
          "s4": {
            "when": "Դիմում",
            "title": "Դիմում ենք առցանց",
            "text": "Լրացնում ենք հայտը պետական պորտալում և պատասխանում Միգրացիոն ծառայության հարցումներին։"
          },
          "s5": {
            "when": "Այց",
            "title": "Մատնահետքեր",
            "text": "Մեկ անգամ պետք է անձամբ գալ Միգրացիոն ծառայություն՝ մատնահետքեր հանձնել և ստորագրել։ Գնում ենք միասին։"
          },
          "s6": {
            "when": "Պատրաստ է",
            "title": "Ստանում եք կացության քարտը",
            "text": "Տեղեկացնում ենք որոշման մասին և օգնում վերցնել քարտը։"
          }
        },
        "blocks": {
          "b1": {
            "title": "Ինչ է փոխվել 2026 թ. նոյեմբերի 1-ից",
            "body": "• «Օտարերկրացիների մասին» օրենքի նոր խմբագրությունն ընդունվել է 2026 թ. հունվարի 20-ին և գործում է նոյեմբերի 1-ից։\n• Դիմումը ներկայացնում են առցանց՝ միասնական պորտալով։ Անձամբ պետք է գալ մեկ անգամ՝ մատնահետքեր հանձնելու և ստորագրելու համար. լիազորագիրը դա չի փոխարինում։\n• Սկզբում տալիս են 1 տարվա կացության քարտ։ Մշտականը՝ 5 տարով, վերջին 5 տարվա ընթացքում 3 տարի ժամանակավոր կացությունից հետո։\n• 1 տարվա կացության պետտուրքը 150 000 ֏ է և 5 950 ֏՝ քարտի համար, մշտականինը՝ 255 950 ֏։\n• Կառավարությունը ներդնում է տարեկան քվոտաներ։ Քվոտան սպառվելուց հետո նոր դիմումներ չեն ընդունում։\n• Էթնիկ հայերի համար հատուկ 10-ամյա կարգավիճակն այլևս չի տրվում. տրված փաստաթղթերը գործում են մինչև ժամկետի ավարտը։\n• Մինչև նոյեմբերի 1-ը ներկայացված դիմումները քննարկվում են հին կանոններով։ Տրված կացության քարտերը գործում են մինչև քարտի վրա նշված ամսաթիվը, նոր կանոնները կիրառվում են երկարաձգման ժամանակ։"
          },
          "b2": {
            "title": "Կացության քարտի հիմքերը",
            "body": "• Աշխատանք՝ աշխատանքային պայմանագիր հայկական ընկերության հետ։ Աշխատաշուկայի ստուգումը վերացվել է, դրա փոխարեն գործում է քվոտա։\n• ԱՁ՝ 1 000 000 ֏ հայկական բանկի հաշվին դիմելու պահին կամ նույնքան շրջանառություն դիմելուց առաջ 60 օրվա ընթացքում։\n• ՍՊԸ՝ կանոնադրական կապիտալում ներդրում կամ բաժնեմասի գնում 2 000 000 ֏-ից։ Եթե հաստատումից հետո 180 օր հարկային հաշվարկ չկա, կացության քարտը կարող են չեղարկել։\n• Ուսում՝ ոչ միայն բուհեր, այլև դասընթացներ, մասնագիտական ուսուցում և փոխանակման ծրագրեր։\n• Ընտանիք՝ Հայաստանի քաղաքացու կամ կացության կարգավիճակ ունեցող օտարերկրացու ամուսին, ծնող կամ երեխա։\nԲնակարանի գնումն ինքնին կացության քարտի իրավունք չի տալիս։"
          },
          "b3": {
            "title": "Ինչ փաստաթղթեր են պետք լինելու",
            "body": "• անձնագիր և դրա նոտարական թարգմանությունը հայերեն.\n• հիմքը հաստատող փաստաթուղթ՝ աշխատանքային պայմանագիր, ԱՁ-ի կամ ՍՊԸ-ի գրանցում, բանկային տեղեկանք, ամուսնության կամ ծննդյան վկայական.\n• սոցքարտ (հանրային ծառայությունների համարանիշ).\n• պետտուրքի վճարման անդորրագիր։\nՃշգրիտ ցանկը սահմանում է կառավարությունը ենթաօրենսդրական ակտերով։ Խորհրդատվության ժամանակ կստուգենք այն գործող տարբերակով։"
          },
          "b4": {
            "title": "Կարելի՞ է ապրել Հայաստանում առանց կացության քարտի",
            "body": "ՌԴ քաղաքացիները մուտք են գործում առանց վիզայի և կարող են մնալ մինչև 180 օր մեկ մուտքի ընթացքում։ Այլ երկրների քաղաքացիների համար կանոններն այլ են։ Եթե ժամկետը մոտենում է ավարտին, իսկ կացության քարտ դեռ չկա, ուշացման համար տուգանք է սպառնում։ Գրեք մեզ նախապես. կասենք, թե ինչ կարելի է հասցնել։"
          },
          "b5": {
            "title": "Կարևոր է",
            "body": "Տեղեկությունն արդիական է 2026 թ. հոկտեմբերի 20-ի դրությամբ։ Կանոնների մի մասը մանրամասնվում է ենթաօրենսդրական ակտերով, ուստի յուրաքանչյուր դիմումից առաջ պահանջները ճշտում ենք Միգրացիոն ծառայության հետ։ Այս տեքստը չի փոխարինում իրավաբանական խորհրդատվությանը։"
          }
        },
        "prices": {
          "p1": {
            "name": "Խորհրդատվություն",
            "value": "{{consult}}",
            "note": "հաշվարկվում է ուղեկցման մեջ"
          },
          "p2": {
            "name": "Ուղեկցում մինչև քարտը",
            "value": "{{escort}}-ից",
            "note": "հիմք, փաստաթղթեր, դիմում, այց"
          },
          "p3": {
            "name": "Պետտուրք՝ 1 տարվա կացություն",
            "value": "{{fee}}",
            "note": "վճարվում է պետությանը, 2026 թ. նոյեմբերի 1-ից"
          },
          "p4": {
            "name": "Պետտուրք՝ 5 տարվա կացություն",
            "value": "255 950 ֏",
            "note": "3 տարի ժամանակավոր կացությունից հետո"
          }
        },
        "faq": {
          "q1": {
            "q": "Որքա՞ն արժե կացության քարտը Հայաստանում 2026-ին",
            "a": "2026 թ. նոյեմբերի 1-ից 1 տարվա կացության պետտուրքը {{fee}} է՝ 150 000 ֏ տուրք և 5 950 ֏ քարտի համար։ ԱՁ հիմքով պետք է նաև 1 000 000 ֏ հաշվին կամ նույնքան շրջանառություն 60 օրում։ Barev Club-ի ուղեկցումը՝ {{escort}}-ից։"
          },
          "q2": {
            "q": "Որքա՞ն պետք է սպասել որոշմանը",
            "a": "Միգրացիոն ծառայությունը նոր համակարգով ժամկետները դեռ չի հրապարակել։ Իրական ժամկետը կասենք խորհրդատվության ժամանակ, երբ նոր կանոններով առաջին որոշումները կլինեն։"
          },
          "q3": {
            "q": "Կարելի՞ է կացության քարտ ստանալ բնակարան գնելով",
            "a": "Ոչ։ Նոր օրենքով անշարժ գույքի սեփականությունն ինքնին կացության քարտի իրավունք չի տալիս։ Պետք են աշխատանք, բիզնես, ուսում կամ ընտանեկան կապ։"
          },
          "q4": {
            "q": "Պե՞տք է անձամբ ներկայանալ",
            "a": "Այո, մեկ անգամ՝ Հայաստանում մատնահետքեր հանձնելու և դիմումը ստորագրելու համար։ Լիազորագիրը դա չի փոխարինում, մնացածն արվում է առցանց։"
          },
          "q5": {
            "q": "Ի՞նչ կլինի իմ արդեն ունեցած կացության քարտի հետ",
            "a": "Այն գործում է մինչև քարտի վրա նշված ժամկետը։ Երկարաձգելիս կիրառվում են նոր կանոնները, նոր տուրքը և առցանց դիմումը։"
          },
          "q6": {
            "q": "Կարելի՞ է միանգամից 5 տարվա կացության քարտ ստանալ",
            "a": "Սովորաբար ոչ. սկզբում տալիս են 1 տարով, իսկ մշտականը՝ վերջին 5 տարում 3 տարի ժամանակավոր կացությունից հետո։ Բացառություն են էթնիկ հայերը, ներդրողները և Հայաստանի առջև հատուկ ծառայություններ ունեցողները։"
          }
        },
        "finalTitle": "Քննարկենք ձեր դեպքը",
        "finalText": "Պատմեք ձեր մասին Telegram-ում. կընտրենք կացության քարտի հիմքը և կհաշվենք ամբողջական արժեքը։"
      },
      "airport": {
        "meta": {
          "title": "Տրանսֆեր Զվարթնոց օդանավակայանից Երևան՝ դիմավորումով — Barev Club",
          "description": "Կդիմավորենք Զվարթնոցում ցուցանակով, կօգնենք ուղեբեռով և կտանենք տուն կամ հյուրանոց Երևանում։ Ստանդարտ՝ {{standard}}, Պրեմիում՝ {{premium}}։ Հետևում ենք չվերթին, 60 րոպե սպասումն անվճար է։"
        },
        "crumb": "Տրանսֆեր օդանավակայանից",
        "h1": "Տրանսֆեր Զվարթնոց օդանավակայանից՝ դիմավորումով",
        "lead": "Վարորդը կդիմավորի ձեզ Զվարթնոց օդանավակայանի ժամանման սրահում ցուցանակով, կօգնի ուղեբեռով և կտանի Երևանի ցանկացած հասցե։ Մինչև կենտրոն ճանապարհը տևում է 20–30 րոպե։ «Ստանդարտը» արժե {{standard}}՝ մեքենայի համար մինչև 3 ուղևոր, «Պրեմիումը»՝ {{premium}}։ Մենք հետևում ենք չվերթին, սպասման առաջին 60 րոպեն անվճար է։",
        "priceLabel": "«Ստանդարտ» դիմավորում",
        "priceValue": "{{standard}}",
        "priceNote": "մինչև 3 ուղևոր, ցուցանակ, 60 րոպե սպասում",
        "facts": {
          "f1": {
            "label": "Որտեղ ենք դիմավորում",
            "value": "ժամանման սրահում՝ ցուցանակով"
          },
          "f2": {
            "label": "Մինչև կենտրոն",
            "value": "20–30 րոպե"
          },
          "f3": {
            "label": "«Ստանդարտ»",
            "value": "{{standard}}"
          },
          "f4": {
            "label": "«Պրեմիում»",
            "value": "{{premium}}"
          }
        },
        "stepsTitle": "Ինչպես է անցնում դիմավորումը",
        "steps": {
          "s1": {
            "when": "Թռիչքից առաջ",
            "title": "Ուղարկում եք չվերթի համարը",
            "text": "Գրում եք Telegram-ում չվերթի համարը, ուղևորների և ճամպրուկների քանակը, Երևանի հասցեն։"
          },
          "s2": {
            "when": "Թռիչքից առաջ",
            "title": "Ստանում եք վարորդի տվյալները",
            "text": "Ուղարկում ենք վարորդի անունը, մեքենայի համարը և չատ նրա հետ բոտում։"
          },
          "s3": {
            "when": "Ժամանում",
            "title": "Հետևում ենք չվերթին",
            "text": "Եթե չվերթը ուշանում է, վարորդը կգա նոր ժամին։ Հավելավճար պետք չէ։"
          },
          "s4": {
            "when": "Ժամանում",
            "title": "Դիմավորում ցուցանակով",
            "text": "Վարորդը սպասում է ժամանման սրահում ձեր անունով ցուցանակով և օգնում է ուղեբեռով։"
          },
          "s5": {
            "when": "30 րոպե անց",
            "title": "Դուք տեղում եք",
            "text": "Տանում ենք բնակարան կամ հյուրանոց Երևանում։"
          }
        },
        "blocks": {
          "b1": {
            "title": "Ինչ է ներառված",
            "body": "• դիմավորում ժամանման սրահում՝ ցուցանակով.\n• օգնություն ուղեբեռով.\n• մինչև 3 ուղևոր «Ստանդարտում».\n• չվերթի հետևում.\n• 60 րոպե անվճար սպասում վայրէջքից հետո.\n• չատ վարորդի հետ բոտի միջոցով։\n«Պրեմիումը» ավելացնում է բիզնես դասի մեքենա, ջուր մեքենայում և հայկական օպերատորի SIM-քարտ, որպեսզի կապը լինի ժամանելուն պես։"
          },
          "b2": {
            "title": "Հյուրանոց առաջին օրերի համար",
            "body": "Եթե դեռ բնակարան չունեք, կամրագրենք հյուրանոց և կտանենք ուղիղ այնտեղ։ Barev+-ով՝ {{hotelPlus}}-ից օրը, առանց բաժանորդագրության՝ {{hotelBase}}-ից։"
          },
          "b3": {
            "title": "Ինչպես այլ կերպ հասնել Զվարթնոցից",
            "body": "• Տաքսի օդանավակայանի կրպակից. ուղեցույցների տվյալներով՝ սովորաբար 3 000–7 000 ֏ մինչև կենտրոն, բայց առանց դիմավորման։\n• Տաքսու հավելվածներ, օրինակ՝ Yandex Go. էժան է, բայց մեքենան պետք է ինքներդ գտնեք կայանատեղիում։\n• Դիմավորումով տրանսֆերն ավելի թանկ է, բայց վարորդը սպասում է ժամանման սրահում, հետևում է չվերթին և օգնում ուղեբեռով։ Հարմար է, եթե թռչում եք ընտանիքով, ուշ երեկոյան կամ առաջին անգամ եք Հայաստանում։"
          }
        },
        "prices": {
          "p1": {
            "name": "«Ստանդարտ»",
            "value": "{{standard}}",
            "note": "մինչև 3 ուղևոր, ցուցանակ, 60 րոպե սպասում"
          },
          "p2": {
            "name": "«Պրեմիում»",
            "value": "{{premium}}",
            "note": "բիզնես դաս, ջուր, SIM-քարտ"
          },
          "p3": {
            "name": "Հյուրանոց Barev+-ով",
            "value": "{{hotelPlus}}-ից",
            "note": "օրը. առանց բաժանորդագրության՝ {{hotelBase}}-ից"
          },
          "p4": {
            "name": "Barev+ բաժանորդագրությամբ",
            "value": "−{{homePct}}%",
            "note": "տրանսֆերի և կենցաղային ծառայությունների համար"
          }
        },
        "faq": {
          "q1": {
            "q": "Որքա՞ն արժե տրանսֆերը Զվարթնոցից մինչև Երևանի կենտրոն",
            "a": "Barev Club-ի հետ՝ {{standard}} մեքենայի համար մինչև 3 ուղևոր՝ դիմավորումով և ցուցանակով, «Պրեմիումը»՝ {{premium}}։ Օդանավակայանի կրպակի տաքսին սովորաբար 3 000–7 000 ֏ է, բայց առանց դիմավորման։"
          },
          "q2": {
            "q": "Ի՞նչ կլինի, եթե չվերթը ուշանա",
            "a": "Մենք հետևում ենք չվերթին, և վարորդը կգա փաստացի վայրէջքի ժամին։ Վայրէջքից հետո առաջին 60 րոպեն անվճար է։"
          },
          "q3": {
            "q": "Որքա՞ն է ճանապարհը օդանավակայանից մինչև Երևանի կենտրոն",
            "a": "Մոտ 20–30 րոպե առանց խցանումների. Զվարթնոց օդանավակայանը գտնվում է կենտրոնից մոտ 12 կմ դեպի արևմուտք։"
          },
          "q4": {
            "q": "Կարելի՞ է տրանսֆեր պատվիրել դեպի օդանավակայան",
            "a": "Այո։ Կտանենք Զվարթնոց Երևանի ցանկացած հասցեից նույն գնով։"
          },
          "q5": {
            "q": "Ինչպե՞ս պատվիրել դիմավորում",
            "a": "Գրեք Telegram-ում չվերթի համարը, ուղևորների քանակը և հասցեն, ցանկալի է վայրէջքից առնվազն մեկ օր առաջ։"
          }
        },
        "finalTitle": "Թռչո՞ւմ եք Երևան",
        "finalText": "Ուղարկեք չվերթի համարը Telegram-ում. կդիմավորենք և կհասցնենք մինչև դուռ։"
      }
    },
    "pay": {
      "cardCta": "Վճարել քարտով",
      "redirecting": "Բացում ենք վճարումը…",
      "orTelegram": "կամ ձևակերպել Telegram-ում",
      "approx": "≈ {{amd}} · ≈ {{rub}}, վճարումը եվրոյով, ավտոերկարաձգում",
      "error": "Չհաջողվեց բացել վճարումը։ Փորձեք կրկին կամ ձևակերպեք Telegram-ում։",
      "metaTitle": "Բաժանորդագրության վճարում — Barev Club",
      "checking": "Ստուգում ենք վճարումը…",
      "pendingTitle": "Սպասում ենք վճարման հաստատմանը",
      "pendingText": "Սովորաբար մի քանի վայրկյան է — էջը կթարմացվի ինքնուրույն։",
      "backToPayment": "Վերադառնալ վճարմանը",
      "paidTitle": "Վճարումն անցավ։ {{plan}}-ը սպասում է ակտիվացման",
      "paidText": "Ակումբը աշխատում է Telegram-ում։ Սեղմեք կոճակը — բոտը կկապի բաժանորդագրությունը ձեր հաշվին, և զեղչերը կգործեն անմիջապես։",
      "activate": "Ակտիվացնել Telegram-ում",
      "renewNote": "Բաժանորդագրությունը երկարաձգվում է ամեն ամիս {{price}}-ով։ Երկարաձգումը կարող եք անջատել հավելվածում՝ «Անդամակցություն» բաժնում։",
      "claimedTitle": "{{plan}}-ը ակտիվացված է",
      "claimedText": "Բաժանորդագրությունը կապված է ձեր Telegram-ին։ Բացեք բոտը — զեղչերն արդեն գործում են։",
      "openBot": "Բացել բոտը",
      "failedTitle": "Վճարումը չանցավ",
      "failedText": "Գումարը չի գանձվել։ Փորձեք կրկին կամ այլ քարտով։",
      "retry": "Փորձել կրկին",
      "refundedTitle": "Վճարումը վերադարձված է",
      "notFoundTitle": "Վճարումը չի գտնվել",
      "notFoundText": "Ստուգեք հղումը կամ գրեք մեզ — կօգնենք։"
    }
  },
  "privacy": {
    "title": "Գաղտնիության քաղաքականություն",
    "updated": "2026 թ. հոկտեմբերի 22-ի խմբագրություն",
    "intro": "Այստեղ գրված է, թե Barev Club-ը ինչ անձնական տվյալներ է հավաքում, ինչու, ում է փոխանցում և ինչպես կարող եք դրանք կառավարել։ Քաղաքականությունը գործում է barevclub.com կայքի, Barev Club-ի Telegram բոտերի և մինի հավելվածների համար։",
    "operator": {
      "title": "Ով է մշակում տվյալները",
      "body": "Անձնական տվյալների մշակողը անհատ ձեռնարկատեր Զաբուդկո Յուրի Կոնստանտինին է (Ա/Ձ), Հայաստանի Հանրապետություն, ՀՎՀՀ {{tin}}։ Barev Club-ը ծառայության անվանումն է։\nՏվյալների վերաբերյալ հարցերով գրեք {{email}} հասցեին, զանգահարեք {{phone}} համարով կամ գրեք բոտի չատում։"
    },
    "data": {
      "title": "Ինչ տվյալներ ենք ստանում",
      "body": "• Telegram-ից՝ ID, օգտանուն, պրոֆիլի անուն և ազգանուն, լեզու։ Հեռախոսահամարը՝ միայն եթե ինքներդ եք այն կիսել։\n• Կայքի հայտեր՝ անուն, հեռախոս կամ Telegram օգտանուն, տեղափոխության ընտրության պատասխաններ (ժամկետներ, անհրաժեշտ ծառայություններ, բյուջե)։ Մաքրման համար՝ հասցե, թաղամաս, ցանկալի ժամ և մեկնաբանություն։\n• Պատվերներ՝ հասցե և թաղամաս, քարտեզի կետ (եթե նշել եք), ծառայության պարամետրեր, ամսաթիվ և ժամ, գին, զեղչ, վճարման կարգավիճակ, մեկնաբանություններ։\n• Փաստաթղթեր՝ անձնագրի և այլ փաստաթղթերի պատճեններ, որոնք վերբեռնում եք «Փաստաթղթեր» ուղղության ծառայությունների համար։\n• Կատարողի հետ նամակագրություն բոտի միջոցով, լուսանկարային հաշվետվություններ, գնահատականներ և կարծիքներ։\n• Անդամակցություն՝ մակարդակ (Barev, Barev+, Elite), բաժանորդագրության ժամկետներ, ակումբային քարտի կոդ և գործընկերների մոտ դրա օգտագործման նշումներ։\n• Աղբյուր՝ գործակալություն կամ պրոմոկոդ, որով եկել եք, և գովազդային արշավների նշիչներ (UTM)։\n• Տեխնիկական տվյալներ՝ կայքի լեզվով cookie, գործակալության կոդը դիտարկչի հիշողությունում և սերվերի մատյաններ (IP հասցե, հարցման ժամ և հասցե)՝ խափանումներից և հարձակումներից պաշտպանվելու համար։\nԲանկային քարտերի տվյալներ չենք ստանում․ առցանց վճարման դեպքում դրանք մուտքագրվում են Tribute վճարային ծառայության էջում (tribute.tg)։"
    },
    "purposes": {
      "title": "Ինչի համար ենք օգտագործում",
      "body": "• Պատվերը ձևակերպելու և կատարելու համար՝ կատարող ընտրել, գինը հաշվել, կարգավիճակների մասին տեղեկացնել։\n• Հայտի վերաբերյալ ձեզ հետ կապվելու և տեղափոխության պլան կազմելու համար։\n• Բաժանորդագրությունը, ակումբային քարտը և զեղչերը վարելու համար։\n• Ձեզ բերած գործակալության պարգևատրումը և կատարողների վճարումները հաշվելու համար։\n• Հաշվապահական և հարկային հաշվառում վարելու համար։\n• Գնահատականների և կարծիքների հիման վրա ծառայությունը բարելավելու համար։\n• Ակումբի նորություններ և առաջարկներ ուղարկելու համար, եթե չեք հրաժարվել։"
    },
    "basis": {
      "title": "Ինչ հիմքով",
      "body": "Տվյալները մշակում ենք ձեր համաձայնության հիման վրա, որը տալիս եք բոտում կամ կայքի ձևում, ինչպես նաև ձեր պատվերը կատարելու և Հայաստանի Հանրապետության օրենսդրության, այդ թվում «Անձնական տվյալների պաշտպանության մասին» օրենքի պահանջները կատարելու համար։\nՀամաձայնությունը կարող եք հետ կանչել ցանկացած պահի։ Դա չի ազդում մինչ այդ կատարված մշակման վրա։"
    },
    "recipients": {
      "title": "Ում ենք փոխանցում տվյալները",
      "body": "Մենք անձնական տվյալներ չենք վաճառում և փոխանցում ենք միայն այն, ինչ անհրաժեշտ է կոնկրետ խնդրի համար․\n• Ձեր պատվերի կատարողին, իսկ եթե պատվերը կատարում է գործընկեր ընկերությունը՝ նաև նրա դիսպետչերին՝ անուն, լեզու, հասցե և պատվերի մանրամասներ։ Ձեր հեռախոսահամարը կատարողին չի ցուցադրվում, շփումը բոտի միջոցով է։\n• Ձեզ բերած անշարժ գույքի գործակալությանը՝ անուն, արդյոք օգտվում եք ակումբից, և վճարված պատվերների գումարները՝ գործակալության պարգևատրումը հաշվելու համար։\n• Ակումբի գործընկերոջը, երբ ցույց եք տալիս ակումբային քարտը՝ անուն և անդամակցության մակարդակ։\n• Telegram-ին. նրա միջոցով են աշխատում բոտերն ու մինի հավելվածները, և Telegram-ը տվյալները մշակում է իր քաղաքականությամբ։\n• Hostinger International-ին. նրա սերվերներում են պահվում տվյալների բազան և ֆայլերը։\n• Tribute վճարային ծառայությանը (tribute.tg), որն ընդունում է առցանց վճարումները՝ email (եթե նշել եք), գումարը, վճարման նպատակը և հաճախորդի ներքին համարը։ Tribute-ը քարտի տվյալները մշակում է իր կողմում՝ իր գաղտնիության քաղաքականությամբ։\n• Պետական մարմիններին, երբ պատվիրում եք փաստաթղթային ծառայություն, և մենք դրանք ներկայացնում ենք ձեր անունից, կամ երբ դա պահանջում է օրենքը։"
    },
    "location": {
      "title": "Որտեղ են պահվում տվյալները",
      "body": "Տվյալների բազան և ֆայլերը պահվում են Գերմանիայում գտնվող սերվերում (Ֆրանկֆուրտ Մայնի վրա, մատակարար՝ Hostinger)։ Գերմանիան Եվրոպական միության անդամ է, որտեղ գործում է Տվյալների պաշտպանության ընդհանուր կանոնակարգը (GDPR)։\nՀամաձայնություն տալով՝ համաձայնում եք տվյալների փոխանցմանը Հայաստանից դուրս։ Telegram-ը կարող է տվյալները մշակել այլ երկրներում։"
    },
    "retention": {
      "title": "Որքան ժամանակ ենք պահում տվյալները",
      "body": "• Պրոֆիլը՝ քանի դեռ օգտվում եք ծառայությունից կամ մինչև ջնջման ձեր հարցումը։\n• Պատվերներն ու վճարումները՝ պատվերի ավարտից 5 տարի. դա պահանջում են հաշվապահական և հարկային հաշվառման կանոնները։\n• Կատարողի հետ նամակագրությունը և լուսանկարային հաշվետվությունները՝ պատվերի ավարտից 1 տարի։\n• Կայքի հայտերը, որոնցով պատվեր չի եղել՝ 12 ամիս։\n• Փաստաթղթերի պատճենները՝ պատվերի ավարտից 90 օր, որից հետո ջնջվում են ավտոմատ։\nԺամկետը լրանալուց հետո տվյալները ջնջվում կամ ապանձնավորվում են։"
    },
    "security": {
      "title": "Ինչպես ենք պաշտպանում տվյալները",
      "body": "• Կայքն ու հավելվածներն աշխատում են միայն HTTPS-ով։\n• Փաստաթղթերի պատճենները պահվում են գաղտնագրված պահոցում։ Դրանց հասանելիություն ունեն միայն օպերատորը և նշանակված կատարողը՝ ժամանակավոր հղումներով, և յուրաքանչյուր դիտում գրանցվում է մատյանում։\n• Ադմին վահանակի մուտքը պաշտպանված է գաղտնաբառով և երկգործոն նույնականացմամբ, ադմինիստրատորների գործողությունները գրանցվում են։\n• Տվյալների բազայի պահուստային պատճենը ստեղծում ենք ամեն օր։"
    },
    "rights": {
      "title": "Ձեր իրավունքները",
      "body": "Դուք կարող եք՝\n• իմանալ, թե ինչ տվյալներ ունենք ձեր մասին, և ստանալ դրանց պատճենը.\n• ուղղել ոչ ճշգրիտ տվյալները.\n• ջնջել տվյալներն ու պրոֆիլը, բացի նրանցից, որոնք օրենքով պարտավոր ենք պահել.\n• հետ կանչել մշակման համաձայնությունը.\n• հրաժարվել նորություններից և առաջարկներից.\n• բողոք ներկայացնել ՀՀ արդարադատության նախարարության Անձնական տվյալների պաշտպանության գործակալություն։\nԳրեք {{email}} հասցեին կամ բոտի չատում։ Կպատասխանենք ՀՀ օրենսդրությամբ սահմանված ժամկետներում։ Առանց մշակման համաձայնության չենք կարողանա նոր պատվերներ ընդունել։"
    },
    "marketing": {
      "title": "Նորություններ և առաջարկներ",
      "body": "Երբեմն բոտում ուղարկում ենք ակումբի նորություններ, ակցիաներ և գործընկերների առաջարկներ։ Հրաժարվել կարող եք ցանկացած պահի՝ գրեք «չեղարկել բաժանորդագրությունը» բոտի չատում կամ {{email}} հասցեին։\nՊատվերների, բաժանորդագրության և գրանցման հիշեցումների մասին հաղորդագրությունները գալիս են անկախ դրանից։"
    },
    "cookies": {
      "title": "Cookie",
      "body": "Կայքը տեղադրում է մեկ cookie՝ barev_lang, ընտրված լեզվով, որպեսզի հաջորդ անգամ բացվի այդ լեզվով։ Եթե եկել եք գործակալության հղումով, նրա կոդը պահվում է դիտարկչի հիշողությունում, որպեսզի զեղչը չկորչի։ Կայքը գովազդային և վերլուծական cookie չի օգտագործում։"
    },
    "age": {
      "title": "Տարիք",
      "body": "Ծառայությունը նախատեսված է չափահասների համար։ Եթե 18 տարեկան չեք, մի փոխանցեք մեզ ձեր տվյալները։ Երեխաների տվյալները, օրինակ ընտանեկան փաստաթղթերի համար, փոխանցում է ծնողը կամ օրինական ներկայացուցիչը և պատասխանատու է դրանց համար։"
    },
    "changes": {
      "title": "Քաղաքականության փոփոխություններ",
      "body": "Կարող ենք թարմացնել քաղաքականությունը։ Գործող խմբագրությունը միշտ այս էջում է, ամսաթիվը նշված է սկզբում։ Էական փոփոխությունների մասին կտեղեկացնենք բոտում։\nՀիմնական տեքստը ռուսերենն է, թարգմանությունները արված են հարմարության համար։"
    }
  },
  "pricing": {
    "title": "Գներ",
    "updated": "Գործում են 2026 թ. հոկտեմբերի 22-ից",
    "intro": "Որքան արժեն Barev Club-ի բաժանորդագրությունը և ակումբի ծառայությունները։ Ծառայություններ կարելի է պատվիրել նաև առանց բաժանորդագրության․ այն միայն ավելացնում է զեղչեր և կոնսիերժ։ Բոլոր գները հայկական դրամով են (֏)։",
    "from": "{{price}}-ից",
    "perDay": "{{price}} մեկ գիշերվա համար",
    "plansTitle": "Ակումբի բաժանորդագրություն",
    "plansNote": "Բաժանորդագրությունը վճարվում է ամսական և երկարաձգվում է, քանի դեռ չեք չեղարկել այն։ Կարող եք չեղարկել ցանկացած պահի․ այն կգործի մինչև վճարված ամսվա ավարտը։",
    "planNote": {
      "free": "Գրանցում Telegram բոտում, առանց վճարի և առանց ժամկետի։",
      "plus": "Ձևակերպվում է բոտում։ Եթե եկել եք գործընկեր անշարժ գույքի գործակալության միջոցով, բաժանորդագրությունը նվեր է (սովորաբար {{days}} օր կամ ավելի, պայմանները սահմանում է գործակալությունը)։",
      "elite": "Ձևակերպվում է ակումբի օպերատորի միջոցով՝ բոտի չատում։"
    },
    "servicesTitle": "Ծառայություններ",
    "servicesNote": "Սրանք բազային գներն են։ Պատվերը հաստատելուց առաջ բոտը ցույց է տալիս ճշգրիտ գինը՝ հաշվի առնելով պարամետրերը և բաժանորդագրության զեղչը։ Հաստատելուց հետո գինը չի փոխվում։",
    "rows": {
      "cleaning": {
        "name": "Բնակարանի մաքրում",
        "note": "Կախված է մաքրման տեսակից և սենյակների քանակից"
      },
      "transferStandard": {
        "name": "Տրանսֆեր «Զվարթնոց» օդանավակայանից, Ստանդարտ",
        "note": "Մինչև 3 ուղևոր, դիմավորում ցուցանակով, 60 րոպե սպասում"
      },
      "transferPremium": {
        "name": "Տրանսֆեր «Զվարթնոց» օդանավակայանից, Պրեմիում",
        "note": "Բիզնես դաս, ջուր, SIM քարտ"
      },
      "hotel": {
        "name": "Հյուրանոց առաջին օրերի համար",
        "note": "Գինը Barev+-ով․ առանց բաժանորդագրության՝ {{base}}-ից մեկ գիշերվա համար"
      },
      "socialCard": {
        "name": "Սոցիալական քարտ՝ ամբողջությամբ",
        "note": "Անձնագրի թարգմանություն, նոտար, գրանցում, ուղեկցում"
      },
      "consultation": {
        "name": "Խորհրդատվություն կացության քարտի վերաբերյալ",
        "note": "Հաշվվում է ուղեկցման արժեքի մեջ"
      },
      "residence": {
        "name": "Կացության քարտի ուղեկցում",
        "note": "Հիմք, փաստաթղթեր, դիմում, այց։ 1 տարվա կացության քարտի {{fee}} պետական տուրքը վճարվում է պետությանը առանձին"
      }
    },
    "payTitle": "Վճարում և չեղարկում",
    "payBody": "Barev+ և Elite բաժանորդագրությունները վճարվում են քարտով եվրոյով՝ կայքում կամ հավելվածում, և ավտոմատ երկարաձգվում են ամեն ամիս․ երկարաձգումը կարելի է անջատել ցանկացած պահի։ Վճարումներն ընդունում է Tribute ծառայությունը, իսկ բաժանորդագրության վճարը վերադարձվում է պահանջով՝ 14 օրվա ընթացքում։ Ծառայությունների պատվերները կարելի է վճարել առցանց հավելվածում (եվրոյով՝ ըստ փոխարժեքի) կամ կանխիկ և փոխանցումով։ Անվճար չեղարկել կամ տեղափոխել պատվերը կարելի է ծառայության սկսվելուց առնվազն 24 ժամ առաջ։ Մանրամասները՝ օգտագործման պայմաններում և վերադարձի կանոններում։"
  },
  "terms": {
    "title": "Օգտագործման պայմաններ",
    "updated": "2026 թ. հոկտեմբերի 22-ի խմբագրություն",
    "intro": "Սրանք այն պայմաններն են, որոնցով Barev Club-ը մատուցում է ծառայություններ barevclub.com կայքի, Telegram բոտերի և մինի-հավելվածների միջոցով։ Պատվեր կամ բաժանորդագրություն ձևակերպելով՝ դուք ընդունում եք այս պայմանները։",
    "about": {
      "title": "Ովքեր ենք մենք և ինչ ենք անում",
      "body": "Barev Club-ը ծառայություն է նրանց համար, ովքեր տեղափոխվում են Հայաստան կամ արդեն ապրում են այստեղ․ կենցաղային ծառայություններ (մաքրում, տրանսֆեր օդանավակայանից, հյուրանոց առաջին օրերի համար), օգնություն փաստաթղթերով (սոցիալական քարտ, կացության քարտ), ուսուցում և ակումբի գործընկերների զեղչեր։\nԾառայությունները մատուցում է անհատ ձեռնարկատեր Զաբուդկո Յուրի Կոնստանտինին (Ա/Ձ Զաբուդկո Յուրի Կոնստանտինի), Հայաստանի Հանրապետություն, ՀՎՀՀ {{tin}}։ Կոնտակտներ՝ {{email}}, {{phone}}։\nՊատվերները կատարում են ստուգված կատարողներ՝ մեր աշխատակիցները կամ գործընկեր ընկերությունները։ Արդյունքի համար ձեր առջև պատասխանատու է Barev Club-ը։"
    },
    "acceptance": {
      "title": "Պայմանների ընդունում",
      "body": "Պայմանները գործում են այն պահից, երբ դուք կայքում կամ բոտում ձևակերպել եք պատվեր, բաժանորդագրություն կամ հայտ։ Ծառայությունից կարելի է օգտվել 18 տարեկանից։\nԵթե համաձայն չեք պայմաններին, մի ձևակերպեք պատվեր։"
    },
    "orders": {
      "title": "Ինչպես է ձևակերպվում պատվերը",
      "body": "• Դուք ընտրում եք ծառայությունը բոտում կամ թողնում եք հայտ կայքում և նշում մանրամասները՝ հասցե, ամսաթիվ, ժամ և այլն։\n• Հաստատելուց առաջ բոտը ցույց է տալիս վերջնական գինը, զեղչը և չեղարկման պայմանները։\n• Պատվերը համարվում է ընդունված, երբ դուք այն հաստատել եք, իսկ մենք նշանակել ենք կատարող։ Այդ և հաջորդ յուրաքանչյուր կարգավիճակի մասին ծանուցում է գալիս։\n• Կատարողի հետ շփումը տեղի է ունենում բոտի չատում։\nԵթե ընտրված ժամին պատվերը կատարել չի հաջողվում, մենք կառաջարկենք այլ ժամ կամ կչեղարկենք պատվերն առանց պահումի։"
    },
    "prices": {
      "title": "Գներ",
      "body": "Գները նշված են հայկական դրամով «Գներ» էջում և բոտում։ Մենք կարող ենք փոխել գները, բայց արդեն հաստատված պատվերի գինը չի փոխվում։\nՊետական տուրքերը և վճարները, օրինակ՝ կացության քարտի տուրքը, ծառայության գնի մեջ ներառված չեն, եթե դա ուղղակիորեն նշված չէ։ Դրանց չափը մենք հայտնում ենք նախապես։"
    },
    "payment": {
      "title": "Վճարում",
      "body": "Barev+ և Barev Elite բաժանորդագրությունները կարելի է վճարել առցանց քարտով՝ կայքում կամ հավելվածում։ Բաժանորդագրությունը ավտոմատ երկարաձգվում է ամեն ամիս նույն քարտից․ երկարաձգումը կարելի է անջատել ցանկացած պահի հավելվածում («Անդամակցություն» բաժին) կամ գրելով մեզ, վճարված ամիսը պահպանվում է։ Ծառայությունների պատվերները կարելի է վճարել առցանց հավելվածում․ գումարը դրամից եվրո է վերահաշվարկվում վճարումից առաջ նշված փոխարժեքով։ Առցանց վճարումներն ընդունում է Tribute վճարային ծառայությունը (tribute.tg)․ քարտի տվյալները մուտքագրվում են նրա էջում, մենք դրանք չենք ստանում և չենք պահում։\nԾառայությունները (մաքրում, տրանսֆեր, փաստաթղթեր և այլն) առցանց չեն վաճառվում․ դրանք վճարվում են կանխիկ կամ փոխանցումով կատարողին կամ փոխանցումով Barev Club-ի հաշվին՝ եղանակը ընտրվում է պատվերում։\nՊահանջի դեպքում տրամադրում ենք վճարման փաստաթուղթ։"
    },
    "cancel": {
      "title": "Չեղարկում և տեղափոխում",
      "body": "Անվճար չեղարկել կամ տեղափոխել պատվերը կարելի է ծառայության սկսվելուց առնվազն 24 ժամ առաջ՝ բոտում կամ օպերատորի հետ չատում։\nԱվելի ուշ չեղարկելու դեպքում պահվում է արժեքի մի մասը։ Դրա չափը նշված է ծառայության քարտում՝ մինչև պատվերի հաստատումը, լռելյայն՝ 30%։\nԵթե պատվերը չեղարկում ենք մենք կամ կատարողը չի եկել, գումարն ամբողջությամբ վերադարձվում է։ Մանրամասները՝ չեղարկման և վերադարձի կանոններում։"
    },
    "subscription": {
      "title": "Barev+ և Barev Elite բաժանորդագրություն",
      "body": "• Բաժանորդագրությունը տալիս է զեղչեր ակումբի ծառայությունների համար, գործընկերների նվերներ և կոնսիերժ չատում։ Մակարդակների բովանդակությունն ու գները՝ «Գներ» էջում։\n• Բաժանորդագրությունը վճարվում է ամսական և ինքնաշխատ երկարաձգվում է, քանի դեռ չեք չեղարկել այն։ Երկարաձգման մասին հիշեցնում ենք 3 օր առաջ։\n• Զեղչը կիրառվում է այն պատվերների նկատմամբ, որոնք ձևակերպվել են բաժանորդագրության գործողության ընթացքում։\n• Գործընկեր գործակալության կոդով նվեր ժամանակահատվածը տրվում է մեկ անգամ մեկ հաճախորդին։\n• Բաժանորդագրությունը կարելի է չեղարկել ցանկացած պահի՝ բոտում կամ օպերատորի հետ չատում։ Այն կգործի մինչև վճարված ժամանակահատվածի ավարտը։"
    },
    "perks": {
      "title": "Գործընկերների զեղչեր և նվերներ",
      "body": "Ակումբային քարտով զեղչերն ու նվերները տրամադրում են ակումբի գործընկերները՝ սրճարաններ, ռեստորաններ և այլ ընկերություններ։ Յուրաքանչյուր առաջարկի պայմանները նշված են գործընկերների կատալոգում։\nԳործընկերոջ ապրանքների և ծառայությունների համար պատասխանատու է գործընկերը։ Գործընկերների առաջարկները կարող են փոխվել և ավարտվել։"
    },
    "docs": {
      "title": "Փաստաթղթային ծառայություններ",
      "body": "Մենք օգնում ենք հավաքել փաստաթղթերը, թարգմանում ենք դրանք, գրանցում և ուղեկցում ենք ձեզ պետական մարմիններում։ Փաստաթղթի կամ կացության քարտի տրամադրման մասին որոշումը կայացնում է պետական մարմինը, և մենք չենք կարող այն երաշխավորել։\nԴուք պատասխանատու եք, որ մեզ փոխանցվող փաստաթղթերն ու տվյալները իսկական և ճշգրիտ են։ Եթե մերժումը կապված է մեր սխալի հետ, մենք այն կուղղենք մեր հաշվին։"
    },
    "client": {
      "title": "Ձեր պարտավորությունները",
      "body": "• Նշել ճիշտ տվյալներ՝ հասցե, կոնտակտներ, պատվերի պարամետրեր։\n• Նշանակված ժամին ապահովել մուտք բնակարան և անվտանգ պայմաններ կատարողի աշխատանքի համար։\n• Հարգալից շփվել կատարողների և օպերատորների հետ։\n• Չօգտագործել ծառայությունը ապօրինի նպատակներով։\nԵթե կատարողը ձեր մեղքով չի կարողացել սկսել աշխատանքը (օրինակ՝ հասցեում ոչ ոք չկա), դա համարվում է ուշ չեղարկում։"
    },
    "quality": {
      "title": "Որակ և բողոքներ",
      "body": "Եթե արդյունքը ձեզ չի գոհացրել, գրեք պատվերի չատում կատարումից հետո 24 ժամվա ընթացքում և, հնարավորության դեպքում, կցեք լուսանկարներ։ Մենք անվճար կուղղենք թերությունները կամ կվերադարձնենք արժեքի մի մասը կամ ամբողջը։\nԵթե կատարողը վնասել է ձեր գույքը, տեղեկացրեք 24 ժամվա ընթացքում․ մենք կուսումնասիրենք և կփոխհատուցենք հաստատված վնասը։"
    },
    "liability": {
      "title": "Պատասխանատվություն",
      "body": "Պատվերի համար մեր պատասխանատվությունը սահմանափակված է դրա արժեքով, բացառությամբ գույքին հաստատված վնասի և այն դեպքերի, երբ օրենքը նման սահմանափակում չի թույլատրում։\nՄենք պատասխանատու չենք այն հանգամանքներով պայմանավորված ուշացումների և չեղարկումների համար, որոնց վրա չենք կարող ազդել՝ պետական մարմինների որոշումներ, չվերթերի ուշացումներ, տարերային աղետներ, Telegram-ի խափանումներ։"
    },
    "content": {
      "title": "Կայքի նյութեր",
      "body": "Տեքստերը, դիզայնը, լոգոն և Barev Club անվանումը պատկանում են ծառայության սեփականատիրոջը։ Առանց թույլտվության դրանք պատճենել չի կարելի։"
    },
    "changes": {
      "title": "Պայմանների փոփոխություններ",
      "body": "Մենք կարող ենք թարմացնել պայմանները։ Գործող խմբագրությունը միշտ այս էջում է, խմբագրության ամսաթիվը նշված է սկզբում։ Արդեն հաստատված պատվերները կատարվում են նախկին պայմաններով։ Բաժանորդագրության էական փոփոխությունների մասին նախապես կտեղեկացնենք բոտում։"
    },
    "law": {
      "title": "Կիրառելի իրավունք և վեճեր",
      "body": "Պայմանների նկատմամբ կիրառվում է Հայաստանի Հանրապետության օրենսդրությունը։ Վեճերը նախ լուծում ենք բանակցությունների միջոցով․ գրեք {{email}} հասցեին, կպատասխանենք 3 աշխատանքային օրվա ընթացքում։ Եթե համաձայնության չգանք, վեճը քննում է Հայաստանի Հանրապետության դատարանը։\nԱյս պայմանները չեն սահմանափակում սպառողի՝ օրենքով սահմանված ձեր իրավունքները։\nՀիմնական տեքստը ռուսերեն է, թարգմանությունները արված են հարմարության համար։"
    }
  },
  "refund": {
    "title": "Չեղարկում և վերադարձ",
    "updated": "2026 թ. հոկտեմբերի 22-ի խմբագրություն",
    "intro": "Երբ և որքան գումար է Barev Club-ը վերադարձնում ծառայությունների և բաժանորդագրության համար, և ինչպես ներկայացնել վերադարձի հարցում։",
    "cancelClient": {
      "title": "Եթե չեղարկում եք դուք",
      "body": "• Ծառայության սկսվելուց 24 ժամ առաջ և ավելի վաղ՝ չեղարկումն ու տեղափոխումն անվճար են, վճարն ամբողջությամբ վերադարձվում է։\n• 24 ժամից պակաս՝ պահվում է արժեքի մի մասը, մնացածը վերադարձվում է։ Պահումի չափը նշված է ծառայության քարտում՝ մինչև պատվերի հաստատումը, լռելյայն՝ 30%։\n• Ծառայությունը սկսվելուց հետո արդեն կատարված մասի արժեքը չի վերադարձվում։"
    },
    "cancelUs": {
      "title": "Եթե չեղարկում ենք մենք",
      "body": "Եթե մենք չեղարկել ենք պատվերը, չենք գտել կատարող կամ կատարողը չի եկել, ընտրում եք դուք՝ տեղափոխում հարմար ժամի կամ գումարի ամբողջական վերադարձ։"
    },
    "quality": {
      "title": "Եթե արդյունքը չի գոհացրել",
      "body": "Գրեք պատվերի չատում կատարումից հետո 24 ժամվա ընթացքում և, հնարավորության դեպքում, կցեք լուսանկարներ։ Մենք անվճար կուղղենք թերությունները, իսկ եթե դա հնարավոր չէ՝ կվերադարձնենք արժեքի մի մասը կամ ամբողջը՝ կախված նրանից, թե ինչն էր սխալ։"
    },
    "subscription": {
      "title": "Barev+ և Barev Elite բաժանորդագրություն",
      "body": "• Բաժանորդագրության ցանկացած վճար ամբողջությամբ վերադարձվում է, եթե խնդրեք դա գանձումից հետո 14 օրվա ընթացքում։\n• Բաժանորդագրությունը կարելի է չեղարկել ցանկացած պահի․ հաջորդ վճարը չի գանձվի, իսկ բաժանորդագրությունը կգործի մինչև վճարված ամսվա ավարտը։\n• Նվեր ժամանակահատվածն անվճար է, դրա համար վերադարձնելու բան չկա։"
    },
    "nonRefundable": {
      "title": "Ինչը չի վերադարձվում",
      "body": "• Պետական տուրքերն ու վճարները, որոնք մենք արդեն վճարել ենք ձեր անունից։\n• Ձեր պատվերի համար երրորդ անձանց մոտ մեր արդեն կատարած ծախսերը՝ օրինակ՝ նոտարական թարգմանություն կամ հյուրանոցի ամրագրում՝ հյուրանոցի կանոններով։\n• Ակումբի գործընկերների ապրանքներն ու ծառայությունները․ դրանց համար գործում են գործընկերոջ կանոնները։"
    },
    "howTo": {
      "title": "Ինչպես պահանջել վերադարձ",
      "body": "Գրեք բոտի չատում կամ {{email}} հասցեին և նշեք պատվերի կամ բաժանորդագրության համարը և պատճառը։ Կպատասխանենք 3 աշխատանքային օրվա ընթացքում։\nԵթե վճարել եք առցանց, գումարը կվերադարձվի նույն քարտին Tribute վճարային ծառայության միջոցով՝ սովորաբար մեր հաստատումից հետո մի քանի աշխատանքային օրվա ընթացքում։"
    },
    "timing": {
      "title": "Վերադարձի ժամկետներ և եղանակ",
      "body": "Գումարը վերադարձվում է նույն եղանակով, որով վճարել եք, վերադարձը հաստատելուց հետո 10 աշխատանքային օրվա ընթացքում։ Քարտին վերադարձը կարող է տևել ևս մի քանի օր՝ կախված բանկից։ Եթե վճարել եք կանխիկ, կվերադարձնենք փոխանցումով կամ կանխիկ՝ ինչպես ձեզ հարմար է։\nՎերադարձի հարցերով՝ {{email}}, {{phone}}։"
    }
  }
}
